import format from "./format.js";

export default {
  app_title: "The Northern Approach",

  "Access Level": "Access Level",
  Accessory: "Accessory | Accessories",
  "Accessory of": "Accessory of",
  Account: "Account | Accounts",
  "Account Email Address": "Account Email Address",
  "Account Number": "Account Number",
  "Account Status": "Account Status",
  Accounting: "Accounting",
  "Accounting role, management, or admin":
    "Accounting role, management, or admin",
  "Accounts Payable": "Accounts Payable",
  "Accounts Receivable": "Accounts Receivable",
  "Accruing x per day at y per month since":
    "Accruing {daily} per day at {rate} per month since",
  "Ack Review": "Ack Review",
  "Acknowledged, awaiting receipt": "Acknowledged, awaiting receipt",
  Acknowledgement: "Acknowledgement | Acknowledgements",
  "Acting as": "Acting as",
  "Add Charge": "Add Charge",
  "Add Checklist Item": "Add Checklist Item",
  Advance: "Advance",
  "Advance Available": "Advance Available",
  Advances: "Advances",
  "At our warehouse": "At our warehouse",
  "Delivery scheduled": "Delivery scheduled",
  "Due Date": "Due Date",
  "Getting started": "Getting started",
  "In service": "In service",
  n_Projects: "No Projects | 1 Project | {count} Projects",
  "No matching invoices": "No matching invoices",
  "No matching projects": "No matching projects",
  "No matching quotes": "No matching quotes",
  "On order": "On order",
  "Owed Back": "Owed Back",
  "Paid In Full": "Paid In Full",
  "Partially installed": "Partially installed",
  "Preparing for delivery": "Preparing for delivery",
  "Save Without Charge": "Save Without Charge",
  "Shipping/Delivery": "Shipping/Delivery",
  "Shipping/Delivery Charge": "Shipping/Delivery Charge",
  "Shipping/Delivery Charge waived": "Shipping/Delivery Charge waived",
  "Internal only": "Internal only",
  Action: "Action",

  "after pay-app advances": "after pay-app advances",
  "Actual Paid": "Actual Paid",
  Activate: "Activate",
  Active: "Active",
  "Active Service": "Active Service",
  "Active service": "Active service",
  "Activity Log": "Activity Log",
  Actual: "Actual",
  "Actual Commission": "Actual Commission",
  "Actual Cost": "Actual Cost",
  "Actual Gross Pay": "Actual Gross Pay",
  "Actual Margin": "Actual Margin",
  "Actual profit margin": "Actual profit margin",
  Add: "Add",
  "Add Accessory": "Add Accessory",
  "Add any notes for internal reference":
    "Add any notes for internal reference",
  "Add Anyway": "Add Anyway",
  "Add Contact": "Add Contact",
  "Add Entry": "Add Entry",
  "Add Location": "Add Location",
  "Add notes about this issue...": "Add notes about this issue...",
  "Add Photos": "Add Photos",
  "Add searchable tags": "Add searchable tags",
  "Add service parts to the sale, then link back to the service issue":
    "Add service parts to the sale, then link back to the service issue",
  "Add Sample": "Add Sample",
  "Add Split": "Add Split",
  "Add Target Contact": "Add Target Contact",
  "Add to Delivery": "Add to Delivery",
  "Add to Services to Schedule": "Add to Services to Schedule",
  "Add Video": "Add Video",
  "Add to Paycheck": "Add to Paycheck",
  Added: "Added",
  "Added from paycheck": "Added from paycheck",
  "Additional Expenses": "Additional Expenses",
  "Additional Information": "Additional Information",
  "Additional field": "Additional field",
  "Additional item - will be added to sale":
    "Additional item - will be added to sale",
  "Additional Items Ready": "Additional Items Ready",
  Address: "Address | Addresses",
  Adjust: "Adjust",
  "Adjust Balance": "Adjust Balance",
  "Adjust Held Pay": "Adjust Held Pay",
  "Adjustment Type": "Adjustment Type",
  Admin: "Admin",
  "Admin/super only": "Admin/super only",
  Administration: "Administration",
  Administrator: "Administrator | Administrators",
  "Affected Item (Optional)": "Affected Item (Optional)",
  After: "After",
  "After customer payments": "After customer payments",
  Afternoon: "Afternoon",
  Agenda: "Agenda",
  "AIA Invoice": "AIA Invoice",
  "AIA Progressive Invoicing": "AIA Progressive Invoicing",
  All: "All",
  "All Categories": "All Categories",
  "All complete": "All complete",
  "All day": "All day",
  "All Issue Types": "All Issue Types",
  "All Issues": "All Issues",
  "All Items": "All Items",
  "All Notifications": "All Notifications",
  "All parts loaded": "All parts loaded",
  "All Parts Loaded": "All Parts Loaded",
  "All Products": "All Products",
  "All Sales": "All Sales",
  "All unresolved issues including QC, loading, and delivery":
    "All unresolved issues including QC, loading, and delivery",
  "All items received": "All items received",
  "All items scanned": "All items scanned",
  "All warehouses": "All warehouses",
  "Already Advanced": "Already Advanced",
  Always: "Always",
  Amount: "Amount",
  "Amount Collected": "Amount Collected",
  "Amount does not match parts": "Amount does not match parts",
  "Amount Due": "Amount Due",
  "Amount Paid": "Amount Paid",
  "Analyzing with AI": "Analyzing with AI",
  "Analyze with AI": "Analyze with AI",
  "Annual Target": "Annual Target",
  "Another salesperson": "Another salesperson",
  "Any additional notes about the completed work...":
    "Any additional notes about the completed work...",
  "Any employee can read and upload": "Any employee can read and upload",
  "Application Date": "Application Date",
  "Applied to Invoice": "Applied to Invoice",
  "Applies to Issue Types": "Applies to Issue Types",
  "Apply Adjustment": "Apply Adjustment",
  "Apply early payment discount": "Apply early payment discount",
  "Apply to All": "Apply to All",
  "Apply to selected": "Apply to selected",
  "Approximate lead time: {0}": "Approximate lead time: {0}",
  Approve: "Approve",
  "Approve & Archive": "Approve & Archive",
  "Approve with Changes": "Approve with Changes",
  Approved: "Approved",
  approved: "approved",
  "Approved as-is": "Approved as-is",
  "Approved Commission": "Approved Commission",
  "Approved with changes": "Approved with changes",
  "Architect/Designer": "Architect/Designer | Architects/Designers",
  Archive: "Archive",
  Archived: "Archived",
  ASAP: "ASAP",
  "Assign Issue to Line Item": "Assign Issue to Line Item",
  "Assess Finance Charge": "Assess Finance Charge",
  "Assign Task": "Assign Task",
  "Assign to Topic": "Assign to Topic",
  "Assigned by": "Assigned by",
  "Assigned to": "Assigned to",
  "Assigned To": "Assigned To",
  Associate: "Associate",
  Attachment: "Attachment | Attachments",
  "Authorized By": "Authorized By",
  Available: "Available",
  "Available Slots for": "Available Slots for",
  "Available to Advance": "Available to Advance",
  "Available Widgets": "Available Widgets",
  "Average days from reported to resolved":
    "Average days from reported to resolved",
  "avg days": "avg days",
  "Avg Days After Parts": "Avg Days After Parts",
  "Avg Days to Complete": "Avg Days to Complete",
  "Avg Days to Order": "Avg Days to Order",
  "Avg Days to Review": "Avg Days to Review",
  Awaiting: "Awaiting",
  "Awaiting Ack": "Awaiting Ack",
  "Awaiting Acknowledgement": "Awaiting Acknowledgement",
  "Awaiting acknowledgement": "Awaiting acknowledgement",
  "Awaiting Bill": "Awaiting Bill",
  "Awaiting bill": "Awaiting bill",
  "Awaiting Down Payment": "Awaiting Down Payment",
  "Awaiting down payment": "Awaiting down payment",
  "Awaiting Parts": "Awaiting Parts",
  "Awaiting parts": "Awaiting parts",
  "Awaiting parts order": "Awaiting parts order",
  "Awaiting Payment": "Awaiting Payment",
  "Awaiting payment": "Awaiting payment",
  "awaiting response": "awaiting response",
  "Awaiting Review": "Awaiting Review",
  "Awaiting review": "Awaiting review",
  Back: "Back",
  "Back to List": "Back to List",
  "Back to Quote": "Back to Quote",
  Balance: "Balance",
  "Balance Due": "Balance Due",
  "Balance will be moved": "Balance will be moved to this contact",
  "Balance x moves to y": "{amount} balance moves to {name}",
  "Base Pay": "Base Pay",
  Bank: "Bank",
  Before: "Before",
  "Begin Transit": "Begin Transit",
  Bill: "Bill | Bills",
  "Bill Payment": "Bill Payment",
  "Bill this punchout as chargeable": "Bill this punchout as chargeable",
  "Bill To": "Bill To",
  "Billed/Shipped": "Billed/Shipped",
  Billing: "Billing",
  "Bills to Pay": "Bills to Pay",
  Bin: "Bin",
  "Bin cap": "Bin cap",
  Bins: "Bins",
  Born: "Born",
  Borrower: "Borrower",
  "Borrower Name (optional)": "Borrower Name (optional)",
  Brand: "Brand",
  "Brands Sold": "Brands Sold",
  BrandSeries: "Brand/Series",
  "Brief description shown in list views":
    "Brief description shown in list views",
  "Brand / Series": "Brand / Series",
  "Break Type": "Break Type",
  "Broken Glass": "Broken Glass",
  "Broken/Missing Hardware": "Broken/Missing Hardware",
  "Builder/Contractor": "Builder/Contractor | Builders/Contractors",
  By: "By",
  by: "by",
  "By Individual": "By Individual",
  "By Location": "By Location",
  "Bypass QC": "Bypass QC",
  Calendar: "Calendar",
  "Calculate Distance": "Calculate Distance",
  "Calculate Route": "Calculate Route",
  "Checked out": "Checked out",
  Columns: "Columns",
  "Confirm Discard": "Confirm Discard",
  "Confirm Drop Off": "Confirm Drop Off",
  "Confirm Return": "Confirm Return",
  "Copy URL": "Copy URL",
  "Current Location": "Current Location",
  "Discard Info": "Discard Info",
  "Edit Sample": "Edit Sample",
  "Field Location": "Field Location",
  Field: "Field",
  "In Office": "In Office",
  "In office": "In office",
  "Last Scanned By": "Last Scanned By",
  "Last Updated": "Last Updated",
  "Leave this sample at a location": "Leave this sample at a location",
  Legend: "Legend",
  "Loading sample...": "Loading sample...",
  "Location Info": "Location Info",
  "Mark Ready for Pickup": "Mark Ready for Pickup",
  "Mark this sample as discarded": "Mark this sample as discarded",
  "Mark this task done": "Mark this task done",
  "Close this task without doing it": "Close this task without doing it",
  "Hand this task back to its creator, with a reason":
    "Hand this task back to its creator, with a reason",
  "Open this task again": "Open this task again",
  "Need this picked up?": "Need this picked up?",
  "New Call Log": "New Call Log",
  "New Mileage Entry": "New Mileage Entry",
  "New Mileage Rate": "New Mileage Rate",
  "Call Log": "Call Log",
  "Call log saved": "Call log saved",
  Cancel: "Cancel",
  "Cancel Sale": "Cancel Sale",
  "Cancel Work Order": "Cancel Work Order",
  Canceled: "Canceled",
  "Card Holder": "Card Holder",
  "Card Type": "Card Type",
  Cash: "Cash",
  "Cash flow": "Cash flow",
  "Cash Sale": "Cash Sale",
  "Cash Sale - Collect Payment": "Cash Sale - Collect Payment",
  "Cash Sale Events Tomorrow": "Cash Sale Events Tomorrow",
  "Cash/no terms": "Cash/no terms",
  Category: "Category | Categories",
  "Category Total": "Category Total",
  "Category x removed": 'Category "{x}" removed',
  CC: "CC",
  Cell: "Cell",
  "Certificate of Insurance": "Certificate of Insurance",
  Change: "Change | Changes",
  "Change Order": "Change Order",
  Changed: "Changed",
  Chargeable: "Chargeable",
  chargeable: "chargeable",
  "Chargeable Items Detected": "Chargeable Items Detected",
  "Chargeable Service": "Chargeable Service",
  "Change Type": "Change Type",
  "Charge from": "Charge from",
  "Check back soon for the next sales competition!":
    "Check back soon for the next sales competition!",
  "Check for updates": "Check for updates",
  Checklist: "Checklist",
  "Checklist Item": "Checklist Item",
  Cheque: "Check",
  "Cheque Date": "Check Date",
  "Cheque Number": "Check Number",
  Children: "Children",
  "Choose one": "Choose one",
  City: "City",
  Claim: "Claim",
  Claimed: "Claimed",
  "Claimed by": "Claimed by",
  Clear: "Clear",
  "Clear All": "Clear All",
  "Clear all": "Clear all",
  "Clear finished": "Clear finished",
  "Clear selection": "Clear selection",
  "Click to schedule": "Click to schedule",
  Close: "Close",
  "Close (progress saved)": "Close (progress is saved)",
  "Close the vendor's warranty case when completed":
    "Close the vendor's warranty case when completed",
  "Close Vendor Case": "Close Vendor Case",
  "Close-up of completed work": "Close-up of completed work",
  Closed: "Closed",
  "Closed Issues": "Closed Issues",
  "Collapse All": "Collapse All",
  "Collect Down Payment": "Collect Down Payment",
  "Collect Material Balance": "Collect Material Balance",
  "Collect Payment": "Collect Payment",
  "Collect Signature": "Collect Signature",
  Collection: "Collection",
  "Comm %": "Comm %",
  Comments: "Comments",
  Commercial: "Commercial",
  "Commercial: Historic": "Commercial — Historic",
  "Commercial: Multi-Family": "Commercial — Multi-Family",
  "Commercial: Office/Retail": "Commercial — Office/Retail",
  Commission: "Commission | Commissions",
  "Commission Advance": "Commission Advance",
  "Commission advance": "Commission advance",
  "Commission Brackets": "Commission Brackets",
  "Commission Leaderboard": "Commission Leaderboard",
  "Commission PO": "Commission PO",
  "Commission Rate": "Commission Rate",
  "Commission Record": "Commission Record | Commission Records",
  "Commission Schedule Change": "Commission Schedule Change",
  "Commission Schedule History": "Commission Schedule History",
  "Commission Split": "Commission Split",
  "Commission Split Given": "Commission Split Given",
  "Commission Type": "Commission Type",
  Company: "Company | Companies",
  "Company or employee covers the cost as goodwill. No quote needed.":
    "Company or employee covers the cost as goodwill. No quote needed.",
  "Company account": "Company account",
  "Company contact": "Company contact",
  companyMatch: {
    address: "same address",
    domain: "same email domain",
    name: "same name",
    phone: "same phone",
  },
  companyRequest: {
    awaitingApproval:
      "Awaiting accounting's approval. Quotes can be sent to it once it's approved.",
    notADuplicateOf: "Marked not a duplicate of {name} ({on})",
    requestedBy: "Requested by {name}. Approve it to let quotes be sent to it.",
  },
  "Company membership": "Company membership",
  "Company Settings": "Company Settings",
  "Company/employee covering cost for customer":
    "Company/employee covering cost for customer",
  Compare: "Compare",
  Comparing: "Comparing",
  Complete: "Complete",
  "Complete Loading": "Complete Loading",
  "Complete Pick-Up": "Complete Pick-Up",
  "Complete required fields first": "Complete required fields first",
  "Complete Review": "Complete Review",
  "Complete Service": "Complete Service",
  "Complete with Punch List": "Complete with Punch List",
  Completed: "Completed",
  completed: "completed",
  "Completed Items": "Completed Items",
  "Complete Receiving": "Complete Receiving",
  "Completed Materials/Labor": "Completed Materials/Labor",
  Completion: "Completion",
  "Completion Notes": "Completion Notes",
  "Completion Photos": "Completion Photos",
  Confirm: "Confirm",
  "Confirm Adjustment": "Confirm Adjustment",
  "Confirm bin": "Confirm bin",
  "Confirm Cancellation": "Confirm Cancellation",
  "Confirm Merge": "Confirm Merge",
  "Confirm Override": "Confirm Override",
  Contact: "Contact | Contacts",

  "Contact Information": "Contact Information",
  "Contact Name": "Contact Name",
  "Converting image...": "Converting image...",
  "Contact an admin or manager to add an address":
    "Contact an admin or manager to add an address",
  "Contact for this service": "Contact for this service",
  Content: "Content",
  Continue: "Continue",
  "Continue from": "Continue from",
  Contract: "Contract | Contracts",
  "Contract Total": "Contract Total",
  "Convert to Accessory": "Convert to Accessory",
  "Convert to Other Charge": "Convert to Other Charge",
  Copy: "Copy",
  "Copy Project Email Address": "Copy Project Email Address",
  Correspondence: "Correspondence",
  correspondence_placeholder:
    "Emails sent to the project email address will appear here.",
  Cost: "Cost",
  "Cost Breakdown": "Cost Breakdown",
  "Cost (Extended)": "Cost (Extended)",
  "Cost of Goods Sold": "Cost of Goods Sold",
  Costs: "Costs",
  Country: "Country",
  County: "County",
  Courtesy: "Courtesy",
  courtesy: "courtesy",
  Create: "Create",
  "Create a new sale for this project to quote service parts":
    "Create a new sale for this project to quote service parts",
  "Create a team to set up automatic commission splits":
    "Create a team to set up automatic commission splits",
  "Create and Send Invoice": "Create and Send Invoice",
  "Create First Team": "Create First Team",
  "Create packing slip": "Create packing slip",
  "Create Paycheck": "Create Paycheck",
  "Create PDF": "Create PDF",
  "Create Quote": "Create Quote",
  "Create Service Quote": "Create Service Quote",
  "Create Task": "Create Task",
  "Create Work Order": "Create Work Order",
  "Create Work Order Now": "Create Work Order Now",
  Created: "Created",
  "Created by": "Created by",
  "Created Date": "Created Date",
  "Created folder": "Created folder",
  Credit: "Credit",
  "Credit Amount": "Credit Amount",
  "Credit Application": "Credit Application",
  "Credit Card": "Credit Card",
  "Credit Card Fee": "Credit Card Fee",
  "Credit Limit": "Credit Limit",
  "Credit Memo": "Credit Memo | Credit Memos",
  "Credit Memo Refund": "Credit Memo Refund",
  "Credit Reference": "Credit Reference | Credit References",
  "Critical Issue": "Critical Issue",
  "Critical Sale Issue": "Critical Sale Issue",
  "Critical sale issues": "Critical sale issue(s)",
  Current: "Current",
  "Current Balance": "Current Balance",
  "Current Held Pay Balance": "Current Held Pay Balance",
  "Currently Scheduled": "Currently Scheduled",
  "Current location": "Current location",
  Custom: "Custom",
  "Cutoff Time": "Cutoff Time",
  "Custom Address": "Custom Address",
  Customer: "Customer | Customers",
  "Customer Absent": "Customer Absent",
  "Customer Feedback": "Customer Feedback",
  "Customer is billed for parts and labor. A quote is required.":
    "Customer is billed for parts and labor. A quote is required.",
  "Customer not present": "Customer not present",
  "Customer Pick-Up": "Customer Pick-Up",
  "Customer portal document":
    "Customer portal document | Customer portal documents",
  "Customer Quote": "Customer Quote | Customer Quotes",
  "Customer Reported": "Customer Reported",
  "Customer Signature": "Customer Signature",
  "Customer Signoff": "Customer Signoff",
  "Customer was not on site": "Customer was not on site",
  "Customer-facing": "Customer-facing",
  "Customize Dashboard": "Customize Dashboard",
  "Damaged Unit": "Damaged Unit",
  "Dark Mode": "Dark Mode",
  Dashboard: "Dashboard",
  "Dashboard updated": "Dashboard updated",
  "Dashboard widgets updated": "Dashboard widgets updated",
  Date: "Date",
  "Date & Time": "Date & Time",
  "Date Born": "Birthdate",
  "Date Completed": "Date Completed",
  "Date Created": "Date Created",
  "Date Due": "Due Date",
  "Date Expected": "Date Expected",
  "Date Hired": "Date Hired",
  "Date Married": "Wedding Anniversary",
  "Date of Payroll": "Date of Payroll",
  "Date of Transaction": "Date of Transaction",
  "Date Paid": "Date Paid",
  "Date Received": "Date Received",
  "Date Referred": "Date Referred",
  "Date Required On Site": "Date Required On Site",
  "Date Sent": "Date Sent",
  "Date Sold": "Date Sold",
  "Date Submitted": "Date Submitted",
  DateTime: "Date/Time",
  Day: "Day | Days",
  "Daylight Opening": "Daylight Opening",
  "Days Open": "Days Open",
  Deactivate: "Deactivate",
  Decline: "Decline",
  "Decline Reason": "Decline Reason",
  Declined: "Declined",
  "Declined with changes": "Declined with changes",
  Decrease: "Decrease",
  "Default Lead Time": "Default Lead Time",
  Defaults: "Defaults",
  "Defer Down Payment": "Defer Down Payment to Accounting",
  "Defer Ordering to Purchasers": "Defer Ordering to Purchasers",
  "Defer Remaining Items": "Defer Remaining Items",
  "Deferred Issues": "Deferred Issues",
  Delete: "Delete",
  "Delete All": "Delete All",
  "Delete permanently": "Delete permanently",
  Deleted: "Deleted",
  "Deleted folder": "Deleted folder",
  Deliver: "Deliver",
  "Deliver + install": "Deliver + install",
  "Deliver only": "Deliver only",
  Delivered: "Delivered",
  delivered: "delivered",
  "Delivered Items": "Delivered Items",
  "Delivered, not installed": "Delivered, not installed",
  "Deliveries to Schedule": "Deliveries to Schedule",
  "Deliveries to Unload": "Undelivered Items",
  Delivery: "Delivery | Deliveries",
  "Deliver to Pickup": "Deliver to Pickup",
  "Delivery Complete": "Delivery Complete",
  "Delivery Contact": "Delivery Contact",
  "Delivery Date": "Delivery Date",
  "Delivery only": "Delivery only",
  "Delivery Proof": "Proof of Delivery",
  "Delivery Report": "Delivery Report",
  "Describe the issue": "Describe the issue",
  Description: "Description",
  "Deselect All": "Deselect All",
  Destination: "Destination",
  "Destination Address": "Destination Address",
  "Detailed Description": "Detailed Description",
  Details: "Details",
  Development: "Development/Neighborhood",
  Difference: "Difference",
  "Different Address": "Different Address",
  "Direct Ship": "Direct Ship",
  Disabled: "Disabled",
  Discard: "Discard",
  Discarded: "Discarded",
  Discount: "Discount",
  "Discount Days": "Discount Days",
  Dismiss: "Dismiss",
  Distance: "Distance",
  "Do not notify": "Do not notify",
  Document: "Document | Documents",
  "Document Library": "Document Library",
  "Does this issue need a site inspection?":
    "Does this issue need a site inspection?",
  "Does this service require parts?": "Does this service require parts?",
  "Document ID": "Document ID",
  Donated: "Donated",
  Done: "Done",
  Down: "Down",
  Doors: "Doors",
  "Down Payment": "Down Payment",
  "Down Payment Received": "Down Payment Received",
  "Drop Off": "Drop Off",
  "Down payment requested": "Down payment requested",
  "Down payment should be x": "Down payment should be {x}",
  "Down payments and invoice payments": "Down payments and invoice payments",
  Download: "Download",
  "Download PDF": "Download PDF",
  Draft: "Draft",
  Drafts: "Drafts",
  "Draw Amount": "Draw Amount",
  Due: "Due",
  Duplicate: "Duplicate",
  "Duplicate to New Lead": "Duplicate to New Lead",
  Duration: "Duration",
  "e.g., Left message with homeowner, work completed per agreement":
    "e.g., Left message with homeowner, work completed per agreement",
  "Early Payment Discount": "Early Payment Discount",
  "Duplicate to New Project": "Duplicate to New Project",
  "Earnings from location-based sales": "Earnings from location-based sales",
  Edit: "Edit",
  "Edit Account": "Edit Account",
  "Edit Acknowledgement": "Edit Acknowledgement",
  "Edit Bill": "Edit Bill",
  "Edit Call Log": "Edit Call Log",
  "Edit Category": "Edit Category",
  "Edit Company": "Edit Company",
  "Edit Contact": "Edit Contact",
  "Edit Credit Memo": "Edit Credit Memo",
  "Edit Entry": "Edit Entry",
  "Edit Event": "Edit Event",
  "Edit Folder": "Edit Folder",
  "Edit Game": "Edit Game",
  "Edit Inventory Item": "Edit Inventory Item",
  "Edit Invoice": "Edit Invoice",
  "Edit Item": "Edit Item",
  "Edit Lead Time": "Edit Lead Time",
  "Edit Mileage Entry": "Edit Mileage Entry",
  "Edit Mileage Rate": "Edit Mileage Rate",
  "Edit Order": "Edit Order",
  "Edit Packing Slip": "Edit Packing Slip",
  "Edit Pay Application": "Edit Pay Application",
  "Edit Paycheck": "Edit Paycheck",
  "Edit Project": "Edit Project",
  "Edit Quote": "Edit Quote",
  "Edit Sale": "Edit Sale",
  "Edit Sales Lead": "Edit Sales Lead",
  "Edit Sales Team": "Edit Sales Team",
  "Edit Sale Issue": "Edit Sale Issue",
  "Edit Service Issue": "Edit Service Issue",
  "Edit Service Lead": "Edit Service Lead",
  "Edit Task": "Edit Task",
  "Edit Topic": "Edit Topic",
  "Edit Transaction": "Edit Transaction",
  "Edit Vehicle": "Edit Vehicle",
  "Edit Vendor Credit": "Edit Vendor Credit",
  "Edit Warehouse": "Edit Warehouse",
  "Edit Work Order": "Edit Work Order",
  Edited: "Edited",
  "Edited folder": "Edited folder",
  "Editing Message": "Editing Message",
  "Effective Date": "Effective Date",
  Eligibility: "Eligibility",
  Email: "Email",
  "Email Address": "Email Address | Email Addresses",
  "Email from x": "Email from {x}",
  "Email functionality coming soon": "Email functionality coming soon",
  Employee: "Employee | Employees",
  employee: "employee | employees",
  "Employee settings saved": "Employee settings saved",
  "Empty folder": "Empty folder",
  Enabled: "Enabled",
  End: "End",
  "End Date": "End Date",
  "End of results": "End of results",
  "End Transit": "End Transit",
  Ended: "Ended",
  ended: "ended", // e.g. "Event ended 5 minutes ago"
  Ends: "Ends",
  ends: "ends",
  "Enter resolution notes": "Enter resolution notes",
  entry: "entry | entries",
  "Equipment Cost": "Equipment Cost",
  "Equipment Rental": "Equipment Rental",
  Equity: "Equity",
  "Error saving settings": "Error saving settings",
  "Est.": "Est.",
  "Est. Hours": "Est. Hours",
  Estimated: "Estimated",
  estimated: "estimated",
  "Estimated Cost": "Estimated Cost",
  "Estimated Hours": "Estimated Hours",
  "Estimated Time": "Estimated Time",
  Estimator: "Estimator",
  Event: "Event | Events",
  "Event Reschedule": "Event Reschedule",
  Everyone: "Everyone",
  Excess: "Excess",
  "Existing Contact": "Existing Contact",
  "Existing Events": "Existing Events",
  "Exit Fullscreen": "Exit Fullscreen",
  "Exit receiving mode": "Exit receiving mode",
  "Expand All": "Expand All",
  Expected: "Expected",
  "Expected Commission": "Expected Commission",
  "Expected Cost": "Expected Cost",
  "Expected Date": "Expected Date",
  "Expected Margin": "Expected Margin",
  "Expected Material": "Expected Material",
  Expense: "Expense | Expenses",
  "Expense Receipt": "Expense Receipt",
  "Expense Submitted": "Expense Submitted",
  "Expense updated": "Expense updated",
  Expired: "Expired",
  Expires: "Expires",
  Export: "Export",
  "Export CSV": "Export CSV",
  "Extracted information": "Extracted information",
  "Extracting images...": "Extracting images...",
  "Export vCard": "Export vCard",
  "Failed to delete entry": "Failed to delete entry",
  "Failed to delete log": "Failed to delete log",
  "Failed to save call log": "Failed to save call log",
  "Failed to save mileage entry": "Failed to save mileage entry",
  "Failed to save sales goal": "Failed to save sales goal",
  "Failed to send email": "Failed to send email",
  "Failed to submit for reimbursement": "Failed to submit for reimbursement",
  Fax: "Fax",
  Feedback: "Feedback",
  "Feedback Request": "Feedback Request",
  Fees: "Fees",
  "Fields required": "Fields required",
  File: "File",
  "File x removed": 'File "{x}" removed',
  File_ext: "File ({ext})",
  Files: "Files",
  "Files without a folder": "Files without a folder",
  "Fill Empty Only": "Fill Empty Only",
  Filter: "Filter",
  "Filter by Location": "Filter by Location",
  "Final Destination": "Final Destination",
  "Final Quote": "Final Quote",
  "Final quote requested": "Final quote requested",
  "Finalized Contract": "Finalized Contract | Finalized Contracts",
  "Finance Charge": "Finance Charge",
  "Finance charge": "Finance charge",
  "Find Duplicates": "Find Duplicates",
  "Finding duplicates...": "Finding duplicates...",
  Finish: "Finish",
  "First Line": "First Line",
  "First Page Totals": "First Page Totals",
  "Fit Height": "Fit Height",
  "Fit Page": "Fit Page",
  "Fit Width": "Fit Width",
  Fixed: "Fixed",
  "Fixed Asset": "Fixed Asset",
  "Fixed on site": "Fixed on site",
  "Flat Rate": "Flat Rate",
  Floor: "Floor",
  Folder: "Folder | Folders",
  "Follow Up": "Follow Up",
  "Follow-up": "Follow-up",
  "Followed up": "Followed up",
  For: "For",
  for: "for",
  "For each issue, record what the inspection found. Confirmed issues advance to quoting/parts/scheduling; issues fixed during the visit are marked resolved.":
    "For each issue, record what the inspection found. Confirmed issues advance to quoting/parts/scheduling; issues fixed during the visit are marked resolved.",
  "For Type": "For Type",
  "Found something new? Wrong parts? Report it here.":
    "Found something new? Wrong parts? Report it here.",
  From: "From",
  "From Held": "From Held",
  "From email": "From email",
  "From message": "From message",
  "From notification": "From notification",
  "From stock": "From stock",
  Fuel: "Fuel",
  "Full Day": "Full Day",
  "Full Unit": "Full Unit | Full Units",
  "Full Units": "Full Units",
  Fullscreen: "Fullscreen",
  "Fully delivered": "Fully delivered",
  "Fully installed": "Fully installed",
  "Fully Received": "Fully Received",
  Future: "Future",
  "Game Name": "Game Name",
  General: "General",
  "General Expense": "General Expense",
  "General Specifications": "General Specifications",
  "Get Directions": "Get Directions",
  Glass: "Glass",
  "Glass Height": "Glass Height",
  "Glass Width": "Glass Width",
  "Go Back": "Go Back",
  Goal: "Goal",
  "Goal Amount": "Goal Amount",
  "Goal Type": "Goal Type",
  "Goal Year": "Goal Year",
  "Google Maps Link": "Google Maps Link",
  "Grid Pattern": "Grid Pattern",
  GPM: "GPM",
  Hardware: "Hardware",
  "Hardware Type": "Hardware Type",
  "Has Grids": "Has Grids",
  "Held Pay": "Held Pay",
  "Held Pay History": "Held Pay History",
  "Held Pay Report": "Held Pay Report",
  "Hide Cost": "Hide Cost",
  "Hide done": "Hide done",
  "Hide seen": "Hide seen",
  "Highest wins": "Highest wins",
  Hired: "Hired",
  History: "History",
  Hold: "Hold",
  "Hold for the project's punchout trip - can be batched with other work at the same location":
    "Hold for the project's punchout trip - can be batched with other work at the same location",
  "Hold Hardware": "Hold Hardware",
  "Hold Reason": "Hold Reason",
  "Hold Screens": "Hold Screens",
  Holding: "Holding",
  Home: "Home",
  Homeowner: "Homeowner | Homeowners",
  Hour: "Hour | Hours",
  hours: "hours",
  "Hours Completed": "Hours Completed",
  "Hours Install Ready": "Installation hours ready to be scheduled",
  "How long will this service take?": "How long will this service take?",
  "How will these parts be billed?": "How will these parts be billed?",
  "How would you like to proceed?": "How would you like to proceed?",
  "How-To Guide": "How-To Guide",
  "I agree to these terms": "I agree to these terms",
  ID: "ID",
  Ignore: "Ignore",
  Ignored: "Ignored",
  "Ignored x false duplicates": "Ignored {count} false duplicates",
  Image: "Image",
  "Image x removed": "Image {x} removed",
  Images: "Images",
  "Images combined": "Images {x} and {y} combined",
  Import: "Import",
  "Import cancelled": "Import cancelled",
  "Import Images": "Import Images",
  "Import Quote": "Import Quote",
  "In-Office Meeting": "In-Office Meeting",
  "Import packing slip": "Import packing slip",
  "In production": "In production",
  "In progress": "In progress",
  "In Stock": "In Stock",
  "In Transit": "In Transit",
  "In transit": "In transit",
  Inactive: "Inactive",
  "Include Labor": "Include Labor",
  "Includes detailed report with attachments":
    "Includes detailed report with attachments",
  Income: "Income",
  Incomplete: "Incomplete",
  Increase: "Increase",
  "Individual Goal": "Individual Goal",
  "Inside Sales": "Inside Sales",
  "Inspection duration": "Inspection duration",
  "Inspection Findings": "Inspection Findings",
  "Inspection visit": "Inspection visit",
  Install: "Install",
  "Incomplete receiving": "Incomplete receiving",
  "Install Status": "Install Status",
  Installation: "Installation | Installations",
  "Installation Complete": "Installation Complete",
  "Installation Report": "Installation Report",
  "Installation Started": "Installation Started",
  "Installations Complete": "Installations Complete",
  "Installations to Schedule": "Installations to Schedule",
  Installed: "Installed",
  "Installed via sale": "Installed via sale",
  Installing: "Installing",
  Internal: "Internal",
  "Internal entries are not visible to customers":
    "Internal entries are not visible to customers",
  "Internal Notes": "Internal Notes",
  "Internal notes": "Internal notes",
  "Internal Notes (not visible to client)":
    "Internal Notes (not visible to client)",
  "Internal Only": "Internal Only",
  Inventory: "Inventory",
  "Inventory Count": "Inventory Count",
  "Inventory Counts": "Inventory Counts",
  "Inventory Disposition": "Inventory Disposition",
  "Inventory Item": "Inventory Item | Inventory Items",
  "Invert in dark mode": "Invert in dark mode",
  Invoice: "Invoice | Invoices",
  "Invoice Date": "Invoice Date",
  "Invoice Number": "Invoice Number",
  "Invoice Payment": "Invoice Payment",
  "Invoice PDF": "Invoice PDF",
  "Invoice Updated": "Invoice Updated",
  "Invoice will be sent to accounting for review upon completion.":
    "Invoice will be sent to accounting for review upon completion.",
  Invoiced: "Invoiced",
  "Invoiced Sales": "Invoiced Sales",
  "IRS Standard Mileage Rate": "IRS Standard Mileage Rate",
  "Is 1099 Eligible": "This account is 1099-eligible",
  "Is Cash Account": "This is a cash account",
  Issue: "Issue | Issues",
  "Issue is locked": "Issue is locked",
  "Issue is ready for next steps": "Issue is ready for next steps",
  "Issue Photos/Videos": "Issue Photos/Videos",
  "Issue Reported": "Issue Reported",
  "Issue Resolved": "Issue Resolved",
  "Issue Type": "Issue Type",
  "Issue Types": "Issue Types",
  Issues: "Issues",
  "Issues Completed": "Issues Completed",
  "Issues open 45+ days (excludes punch list)":
    "Issues open 45+ days (excludes punch list)",
  "Issues Ready for Service": "Issues Ready for Service",
  "Issues Resolved": "Issues Resolved",
  "Issues to Address": "Issues to Address",
  "Issues Under Review": "Issues Under Review",
  "Issues Waiting on Parts": "Issues Waiting on Parts",
  "Issues with parts required but not yet received":
    "Issues with parts required but not yet received",
  Item: "Item | Items",
  "Item already received": "Item already received",
  "Item found": "Item found",
  "Item is locked": "Item is locked",
  "Item Location": "Item Location | Item Locations",
  "Item matched": "Item matched",
  "Item options": "Item options",
  "Item received at": "Item received at",
  "Item removed": "Item removed",
  "Items removed": "Items removed",
  "Item x converted": "Item {x} converted",
  "Item x duplicated": "Item {x} duplicated",
  "Item x removed": "Item {x} removed",
  "Itemized Pricing": "Itemized Pricing",
  Items: "Items",
  items: "items",
  "Items at Temporary Destination": "Items at Temporary Destination",
  "Items Delivered": "Items delivered",
  "Items Delivery Ready": "Items ready to be scheduled for delivery",
  "Items Delivery Scheduled": "Items scheduled to be delivered",
  "Items install ready": "Items ready to be scheduled for installation",
  "Items Install Ready": "Items ready to be scheduled for installation",
  "Items Install Scheduled": "Items scheduled to be installed",
  "Items installed": "Items installed",
  "Items of Interest": "Items of Interest",
  "Items Installed": "Items installed",
  "Items picked up": "Items picked up",
  "Items pickup ready": "Items ready to be scheduled for pickup",
  "Ive Arrived": "I've Arrived",
  "Job Address": "Job Address",
  "Job Cost": "Job Cost",
  Jobsite: "Jobsite",
  "Jump to Present": "Jump to Present",
  "Just this time": "Just this time",
  "Knowledge Base": "Knowledge Base",
  "Knowledge Base Entry": "Knowledge Base Entry",
  Keep: "Keep",
  "Keep x": "Keep {name}",
  Label: "Label",
  "Label size": "Label size",
  Labor: "Labor",
  "Labor also covered": "Labor also covered",
  "Labor Cost": "Labor Cost",
  "Labor Description": "Labor Description",
  "Labor Report": "Labor Report",
  "Labor Started": "Labor Started",
  "Last Four Digits": "Last Four Digits",
  "Last Manual Adjustment": "Last Manual Adjustment",
  "Last Page Totals": "Last Page Totals",
  "Last Year": "Last Year",
  Latest: "Latest",
  Latitude: "Latitude",
  "Lead Name": "Lead Name",
  "Lead Time": "Lead Time | Lead Times",
  Leaderboard: "Leaderboard",
  "Leave empty to apply to all issue types":
    "Leave empty to apply to all issue types",
  "Legal Documents": "Other Legal Documents",
  "Letter of Intent": "Letter of Intent",
  libraryUploadPreparing:
    "Creating folders and reading files ({count} found so far)",
  libraryUploadSummary: "{done} of {total} uploaded",
  Line: "Line",
  "Listed at this company": "Listed at this company",
  "Load Defaults": "Load Defaults",
  "Load more": "Load more",
  "Load onto Vehicle": "Load onto Vehicle",
  "Load Parts": "Load Parts",
  "Load Parts for Service": "Load Parts for Service",
  "Load More": "Load More",
  Loaded: "Loaded",
  loaded: "loaded",
  "Loaded onto": "Loaded onto",
  Loading: "Loading",
  "Loading Complete": "Loading Complete",
  "Loading in progress": "Loading in progress",
  "Loading onto truck": "Loading onto truck",
  "Loading Started": "Loading Started",
  "Loading Truck": "Loading Truck",
  Location: "Location | Locations",
  "Location not set": "Location not set",
  "Location set": "Location set",
  "Location set to": "Location set to",
  Lock: "Lock",
  "Lock Problem": "Lock Problem",
  Locked: "Locked",
  Log: "Log | Logs",
  "Log Call": "Log Call",
  "Log deleted": "Log deleted",
  "Log In": "Log In",
  "Log Out": "Log Out",
  "Long Term Liability": "Long Term Liability",
  Longitude: "Longitude",
  "Look Up": "Look Up",
  Lost: "Lost",
  "Keep mine": "Keep mine",
  Lot: "Lot",
  "Lot Number": "Lot Number",
  Mail: "Mail",
  "Mail Error": "Mail Error",
  "Mail Success": "Mail Success",
  Maintenance: "Maintenance",
  "Maintenance required": "Maintenance required",
  "Man-hours": "Man-hours",
  "Manage Columns": "Manage Columns",
  Management: "Management",
  "Management role or admin": "Management role or admin",
  "Managed Location": "Managed Location | Managed Locations",
  Manager: "Manager",
  "Manager Share": "Manager Share",
  "Manager share": "Manager share",
  "Manager share description":
    "Location managers earn a percentage from completed sales by salespeople at their location who are NOT on their sales team.",
  "Manager share is additive (does not reduce others)":
    "Manager share is additive (does not reduce others)",
  "Manager Share Settings": "Manager Share Settings",
  Manual: "Manual",
  "Manual decrease": "Manual decrease",
  "Manual Entry": "Manual Entry",
  "Manual increase": "Manual increase",
  "Manufacturing Defect": "Manufacturing Defect",
  "Manually Complete": "Manually Complete",
  "Map Link": "Map Link",
  Margin: "Margin",
  "Mark all done": "Mark all done",
  "Mark All Done": "Mark all as done",
  "Mark All Seen": "Mark all as seen",
  "Mark as Completed": "Mark as Completed",
  "Mark as Paid": "Mark as Paid",
  "Mark as Reviewed": "Mark as Reviewed",
  "Mark Punched Out": "Mark Punched Out",
  "Mark as reviewed once all required info is filled in":
    "Mark as reviewed once all required info is filled in",
  "Mark all seen": "Mark all seen",
  "Mark as additional item": "Mark as additional item",
  "Mark Done": "Mark as done",
  "Mark Not Received": "Mark Not Received",
  "Mark Received": "Mark Received",
  "Mark Reviewed": "Mark Reviewed",
  "Mark Seen": "Mark as seen",
  "Mark Undone": "Mark as undone",
  "Mark Unread": "Mark unread",
  "Mark Unseen": "Mark as unseen",
  Markup: "Markup",
  Married: "Married",
  Match: "Match | Matches",
  "Matching Project Found": "Matching Project Found",
  Material: "Material",
  "Material Received": "Material Received",
  "Material received": "Material received",
  "Material Status": "Material Status",

  "Match to": "Match to",
  "Match to acknowledgement": "Match to acknowledgement",
  "Matched items": "Matched items",
  "Matched to": "Matched to",
  Materials: "Materials",
  "Materials Cost": "Materials Cost",
  Max: "Max", // Maximum
  "Max Height": "Max Height",
  "Max Margin": "Max Margin",
  "Max Weeks": "Max Weeks",
  Maximize: "Maximize",
  Media: "Media",
  Member: "Member | Members",
  Memo: "Memo",
  Merge: "Merge",
  "Merge Preview": "Merge Preview",
  Message: "Message | Messages",
  "Message from x": "Message from {x}",
  Messaging: "Messaging",
  Midday: "Midday",
  Mileage: "Mileage",
  "Mileage Entry": "Mileage Entry",
  "Mileage entry saved": "Mileage entry saved",
  "Mileage Log": "Mileage Log",
  "Mileage Rate": "Mileage Rate | Mileage Rates",
  Photo: "Photo",
  "Rate per Mile": "Rate per Mile",
  "Reason for Discarding": "Reason for Discarding",
  "Remind the assignee when it's due": "Remind the assignee when it's due",
  Return: "Return",
  "Mark as returned at your current location":
    "Mark as returned at your current location",
  Sample: "Sample | Samples",
  "Sample Action": "Sample Action",
  "Sample Map": "Sample Map",
  "Sample QR Code": "Sample QR Code",
  "Sample Tracking": "Sample Tracking",
  Samples: "Samples",
  "Scan Action": "Scan Action",
  "Scan Sample": "Scan Sample",
  "Select Action": "Select Action",
  Source: "Source",
  Miles: "Miles",
  miles: "mile | miles",
  Min: "Min", // Minimum
  "Min Height": "Min Height",
  "Min Margin": "Min Margin",
  "Min Weeks": "Min Weeks",
  "Minimum 2 photos required:": "Minimum 2 photos required:",
  "Minimum Project Total": "Minimum Project Total",
  "Missed Events": "Missed Events",
  Modified: "Modified",
  "Monday's Agenda": "Monday's Agenda",
  Month: "Month | Months",
  "Monthly Summary": "Monthly Summary",
  Morning: "Morning",
  Move: "Move",
  "Move delivered items to inventory":
    "Move delivered or in-transit items to inventory",
  "Move to Folder": "Move to Folder",
  "Move undelivered items to inventory": "Move undelivered items to inventory",
  "Moved file": "Moved file",
  "Moved folder": "Moved folder",
  "Moved to service": "Moved to service",
  "Moved to Trash": "Moved to Trash",
  "Must be completed right away, as soon as any parts arrive":
    "Must be completed right away, as soon as any parts arrive",
  "My Files": "My Files",
  more: "more",
  "Moving x portal documents":
    "Moving 1 customer portal document | Moving {count} customer portal documents",
  "My Location": "My Location",
  "My Preferences": "My Preferences",
  "My Projects": "My Projects",
  n_Acknowledgements:
    "No Acknowledgements | 1 Acknowledgement | {count} Acknowledgements",
  n_additional_items_will_be_added:
    "No additional items | 1 additional item will be added to the sale | {count} additional items will be added to the sale",
  n_AdditionalExpenses:
    "No Additional Expenses | 1 Additional Expense | {count} Additional Expenses",
  n_Bills: "No Bills | 1 Bill | {count} Bills",
  n_Brackets: "1 Bracket | {count} Brackets",
  n_CashSaleEventsTomorrow:
    "No Cash Sale Events Tomorrow | 1 Cash Sale Event Tomorrow | {count} Cash Sale Events Tomorrow",
  n_CommissionsReady:
    "1 commission ready for approval | {count} commissions ready for approval",
  n_CreditMemos: "1 Credit Memo | {count} Credit Memos",
  n_Days: "1 Day | {count} Days",
  n_days_open: "1 day open | {count} days open",
  n_Deliveries: "No Deliveries | 1 Delivery | {count} Deliveries",
  n_Events: "No Events | 1 Event | {count} Events",
  n_Expenses: "No Expenses | 1 Expense | {count} Expenses",
  n_Files: "No Files | 1 File | {count} Files",
  n_Hours: "1 Hour | {count} Hours",
  n_hours: "1 hour | {count} hours",
  n_Installations: "No Installations | 1 Installation | {count} Installations",
  n_Invoices: "No Invoices | 1 Invoice | {count} Invoices",
  n_Issues: "No Issues | 1 Issue | {count} Issues",
  n_Items: "No Items | 1 Item | {count} Items",
  n_LaborExpenses:
    "No Labor Expenses | 1 Labor Expense | {count} Labor Expenses",
  n_Leads: "No Leads | 1 Lead | {count} Leads",
  n_SaleIssues: "No Sale Issues | 1 Sale Issue | {count} Sale Issues",
  n_Lines: "No Lines | 1 Line | {count} Lines",
  n_manHours: "1 man-hour | {count} man-hours",
  n_Members: "No Members | 1 Member | {count} Members",
  n_Messages: "No Messages | 1 Message | {count} Messages",
  n_minutes: "1 minute | {count} minutes",
  n_MissedEvents: "No Missed Events | 1 Missed Event | {count} Missed Events",
  n_open: "0 open | 1 open | {count} open",
  n_Orders: "No Orders | 1 Order | {count} Orders",
  n_PackingSlips: "No Packing Slips | 1 Packing Slip | {count} Packing Slips",
  n_Pay_Applications:
    "No Pay Application | 1 Pay Application | {count} Pay Applications",
  n_PreviousSchedules:
    "No previous schedules | 1 previous schedule | {count} previous schedules",
  n_Quotes: "No Quotes | 1 Quote | {count} Quotes",
  n_resolved: "0 resolved | 1 resolved | {count} resolved",
  n_Sales: "No Sales | 1 Sale | {count} Sales",
  n_Services: "No Services | 1 Service | {count} Services",
  n_stops: "1 stop | {count} stops",
  n_Tasks: "No Tasks | 1 Task | {count} Tasks",
  n_Transactions: "No Transactions | 1 Transaction | {count} Transactions",
  n_UnitsAffected: "1 Unit Affected | {count} Units Affected",
  n_withoutCaseNumber:
    "None without a case number | 1 without a case number | {count} without a case number",
  "N/A": "N/A",
  Name: "Name",
  "need inspection": "need inspection",
  "need quotes": "need quotes",
  "Needs inspection": "Needs inspection",
  "Needs order": "Needs order",
  "Needs Parts": "Needs Parts",
  "Needs Parts → Ordered": "Needs Parts → Ordered",
  "Needs Parts Ordered": "Needs Parts Ordered",
  "Needs Quote": "Needs Quote",
  "Needs quote": "Needs quote",
  "Needs Review": "Needs Review",
  "Needs scheduled": "Needs scheduled",
  "Needs Service Quote": "Needs Service Quote",
  "Needs Site Inspection": "Needs Site Inspection",
  "Net Days": "Net Days",
  "Never delivered": "Never delivered",
  New: "New",
  "New Account": "New Account",
  "New Acknowledgement": "New Acknowledgement",
  "New Address": "New Address",
  "New balance: {amount}": "New balance: {amount}",
  "New Bill": "New Bill",
  "New Cash Sale Delivery": "New Cash Sale Delivery",
  "New Category": "New Category",
  "New Company": "New Company",
  "New Construction Installation": "New Construction Installation",
  "New Contact": "New Contact",
  "New Credit Memo": "New Credit Memo",
  "New Document": "New Document",
  "New Entry": "New Entry",
  "New Event": "New Event",
  "New Expense": "New Expense",
  "New Folder": "New Folder",
  "New Game": "New Game",
  "New Instance": "New Instance",
  "New Inventory Item": "New Inventory Item",
  "New Invoice": "New Invoice",
  "New Issue": "New Issue",
  "New Issues Found": "New Issues Found",
  "New Item": "New Item",
  "New Knowledge Base Entry": "New Knowledge Base Entry",
  "New item": "New item",
  "New Lead Time": "New Lead Time",
  "New Library Folder": "New Library Folder",
  "New Man-Hours": "New Man-Hours",
  "New Message": "New Message",
  "New Order": "New Order",
  "New Packing Slip": "New Packing Slip",
  "New Password": "New Password",
  "New Pay Application": "New Pay Application",
  "New Quote": "New Quote",
  "New Sale": "New Sale",
  "New Sample": "New Sample",
  "New Quote Response": "New Quote Response",
  "New Role Assigned": "New Role Assigned",
  "New Sales Game Started!": "New Sales Game Started!",
  "New Sales Lead": "New Sales Lead",
  "New Sale Issue": "New Sale Issue",
  "New Sales Team": "New Sales Team",
  "New Series": "New Series",
  "New Series Lead Time": "New Series Lead Time",
  "New Service Issue": "New Service Issue",
  "New Service Lead": "New Service Lead",
  "New Service Work Order": "New Service Work Order",
  "New since your last update": "New since your last update",
  "New Task": "New Task",
  "New Team": "New Team",
  "New Topic": "New Topic",
  "New Transaction": "New Transaction",
  "New Vehicle": "New Vehicle",
  "New Vendor Credit": "New Vendor Credit",
  "New Work Order": "New Work Order",
  "Newly Delivered": "Newly Delivered",
  "Newly Installed": "Newly Installed",
  Next: "Next",
  "Next Stop": "Next Stop",
  No: "No",
  "No Active Games": "No Active Games",
  "No address": "No address",
  "No amount": "No amount",
  "No brand data": "No brand data",
  "No changes to show yet.": "No changes to show yet.",
  "No camera found": "No camera found",
  "No Commission": "No Commission",
  "No commission due": "No commission due",
  "No completed service history": "No completed service history",
  "No contact info available": "No contact info available",
  "No contacts to export": "No contacts to export",
  "No correspondence yet": "No correspondence yet",
  "No Customer On Site": "No Customer On Site",
  "No data for selected period": "No data for selected period",
  "No description": "No description",
  "No Document": "No Document",
  "No duplicates found": "No duplicates found",
  "No employees need a paycheck at this time.":
    "No employees need a paycheck at this time.",
  "No employees need reminders at this time.":
    "No employees need reminders at this time.",
  "No events scheduled": "No events scheduled",
  "No groups can be merged": "None of the selected groups can be merged",
  "No held pay activity yet": "No held pay activity yet",
  "No issues assigned to this work order.":
    "No issues assigned to this work order.",
  "No items detected yet": "No items detected yet",
  "No items found": "No items found",
  "No matches found": "No matches found",
  "No matching issues": "No matching issues",
  "No items received yet": "No items received yet",
  "No matching item found": "No matching item found",
  "No Material": "No Material",
  "No members added yet": "No members added yet",
  "No One Present": "No One Present",
  "No open issues found": "No open issues found",
  "No open service issues": "No open service issues",
  "No parts to load for this work order.":
    "No parts to load for this work order.",
  "No paychecks found": "No paychecks found",
  "No projects found": "No projects found",
  "No received items pending delivery/installation.":
    "No received items pending delivery/installation.",
  "No sales can take an advance": "No sales can take an advance",
  "No results": "No results",
  "Under review": "Under review",
  "View QR Code": "View QR Code",
  "What's New": "What's New",
  "Version {version}": "Version {version}",
  "Previous releases": "Previous releases",
  "Show changes for all roles": "Show changes for all roles",
  "Show fewer": "Show fewer",
  "Select or create a game to view the leaderboard":
    "Select or create a game to view the leaderboard",
  "No sales recorded yet this year": "No sales recorded yet this year",
  "No sales teams yet": "No sales teams yet",
  "No service": "No service",
  "No service issues for this project": "No service issues for this project",
  "No target contacts set for this year":
    "No target contacts set for this year",
  "No targets set": "No targets set",
  "No tasks yet": "No tasks yet",
  "No tips available for this issue type":
    "No tips available for this issue type",
  "No undelivered stock remains for this sale.":
    "No undelivered stock remains for this sale.",
  "No unpaid entries found for this month":
    "No unpaid entries found for this month",
  "No updates found": "No updates found",
  "Non-Posting": "Non-Posting",
  "Non-Taxable": "Non-Taxable",
  None: "None",
  Normal: "Normal",
  "Normal priority - schedule when convenient":
    "Normal priority - schedule when convenient",
  "Not a duplicate": "Not a duplicate",
  "Not a location manager": "Not a location manager",
  "Not Billable": "Not Billable",
  "Not completed": "Not completed",
  "Not Now": "Not Now",
  "Not on this delivery": "Not on this delivery",
  "Not ordered": "Not ordered",
  "Not received": "Not received",
  "Not Required": "Not Required",
  "Not scheduled": "Not scheduled",
  "not scheduled": "not scheduled",
  "Not specified": "Not specified",
  "Not started": "Not started",
  Note: "Note",
  Notes: "Notes",
  "Notes and Checklist": "Notes and Checklist",
  "Nothing on hold": "Nothing on hold",
  Notification: "Notification | Notifications",
  "Notification Settings": "Notification Settings",
  Notify: "Notify",
  "Notify Customer": "Notify Customer",
  "Notify of Finance Charge": "Notify of Finance Charge",
  Now: "Now",
  Occupied: "Occupied",
  of: "of",
  "of goal": "of goal",
  "of team": "of team",
  "of sale": "of sale",
  Office: "Office",
  "Office Locations": "Office Locations",
  "Home Location": "Home Location",
  "Return to {location}": "Return to {location}",
  "Could not get location. Continuing without GPS.":
    "Could not get location. Continuing without GPS.",
  "Location access denied. GPS tracking will be unavailable.":
    "Location access denied. GPS tracking will be unavailable.",
  OK: "OK",
  Optional: "Optional",
  Options: "Options",
  Older: "Older",
  "Old Schedule": "Old Schedule",
  "On hold": "On hold",
  "on hold": "on hold",
  "On site": "On site",
  Ongoing: "Ongoing",
  "Only when relevant to you": "Only when relevant to you",
  ooo: {
    assigneeWarning:
      "{name} is currently out of office (back {date}). This task may be delayed.",
    dueDateConflict: "The due date falls within {name}'s scheduled time off.",
    outFrom: "Out {from} – {to}",
    outUntil: "Out until {date}",
    tooltipCurrent: "{name} is out of office until {end}.",
    tooltipUpcoming: "{name} will be out of office from {start} until {end}.",
  },
  Open: "Open",
  "Open current invoices": "Open current invoices",
  "Open invoices": "Open invoices",
  "open issue": "open issue",
  "Open Issues": "Open Issues",
  "Open Issues ({count})": "Open Issues ({count})",
  "Open Sales Leads": "Open Sales Leads",
  "Open Service Issues": "Open Service Issues",
  "Open Tasks": "Open Tasks",
  "Open window/door and test the hardware in the open position. If it works, it has something to do with the strike and how it engages. Make adjustments to the keeper/strikes.":
    "Open window/door and test the hardware in the open position. If it works, it has something to do with the strike and how it engages. Make adjustments to the keeper/strikes.",
  "Operation Type": "Operation Type",
  "Open/Unresolved Issues": "Open/Unresolved Issues",
  "or enter address manually": "or enter address manually",
  "or select a project": "or select a project",
  "Or enter code manually": "Or enter code manually",
  "Or select from order": "Or select from order",
  Order: "Order | Orders",
  "Order By": "Order By",
  "Order Copy": "Order Copy | Order Copies",
  "Order created": "Order created",
  "Order Cutoff": "Order Cutoff",
  "Order Cutoff Day": "Order Cutoff Day",
  "Order Date": "Order Date",
  "Order Description": "Order Description",
  "Order Line": "Order Line",
  "Order Parts": "Order Parts",
  "Order Placed": "Order Placed",
  "Order PO": "Order PO",
  Ordered: "Ordered",
  "Ordered, awaiting ack": "Ordered, awaiting ack",
  "Ordering claimed by": "Ordering claimed by",
  "Ordering deferred to purchasers": "Ordering deferred to purchasers",
  "Original message deleted": "Original message was deleted",
  Other: "Other",
  "Other Acknowledgements": "Other Acknowledgements",
  "Other Asset": "Other Asset",
  "Other Change": "Other Change | Other Changes",
  "Other Charge": "Other Charge | Other Charges",
  "Other Current Asset": "Other Current Asset",
  "Other Current Liability": "Other Current Liability",
  "Other Expense": "Other Expense",
  "Other Income": "Other Income",

  "Other Quotes": "Other Quotes",
  Override: "Override",
  "Override confirmed": "Override confirmed",
  "Override Reason": "Reason for manual override",
  "Out of commission": "Out of commission",
  "Out of Office": "Out of Office",
  Outstanding: "Outstanding",
  "Overall product view": "Overall product view",
  Overdue: "Overdue",
  "Overdue invoices": "Overdue invoices",
  "Overdue Issues": "Overdue Issues",
  "Overdue Only": "Overdue Only",
  "Packing Slip": "Packing Slip | Packing Slips",
  PackingSlips: "Packing Slips",
  Paid: "Paid",
  "Paid as": "Paid as",
  "Paid but incomplete": "Paid but incomplete",
  "Paid in full": "Paid in full",
  "Paid-in-full requirement waived": "Paid-in-full requirement waived",
  "Parent Item": "Parent Item",
  "Part/Issue": "Part/Issue",
  "Paid in full up front": "Paid in full up front",
  Partial: "Partial",
  "Partial delivery quantities are invalid":
    "Partial delivery quantities are invalid",
  "Partially complete": "Partially complete",
  "Partially Delivered": "Partially Delivered",
  "Partially delivered": "Partially delivered",
  "Partially picked up": "Partially picked up",
  "Partially ready for approval": "Partially ready for approval",
  Participant: "Participant | Participants",
  Parts: "Parts",
  "Parts covered by manufacturer warranty. A quote is still needed for labor.":
    "Parts covered by manufacturer warranty. A quote is still needed for labor.",
  "Parts covered under manufacturer warranty":
    "Parts covered under manufacturer warranty",
  "Parts Notes": "Parts Notes",
  "Parts Ordered": "Parts Ordered",
  "Parts ordered": "Parts ordered",
  "Parts Pending": "Parts Pending",
  "Parts pending": "Parts pending",
  "Parts Photos": "Parts Photos",
  "Parts Ready": "Parts Ready",
  "Parts Received": "Parts Received",
  "Parts received": "Parts received",
  "Parts Received → Resolved": "Parts Received → Resolved",
  "Parts Required": "Parts Required",
  "Parts required": "Parts required",
  "Parts to Deliver": "Parts to Deliver",
  "Parts to Load": "Parts to Load",
  "Parts will be billed to customer": "Parts will be billed to customer",
  "Parts/Items Loaded": "Parts/Items Loaded",
  Password: "Password",
  Past: "Past",
  "Past Due": "Past Due",
  "Past expected date": "Past expected date",
  "Paste embed code from video provider":
    "Paste embed code from video provider",
  Pay: "Pay",
  "Pay Application": "Pay Application | Pay Applications",

  "PR #": "PR #",
  Payroll: "Payroll",
  "Payroll Date": "Payroll Date",
  "Payroll Information": "Payroll Information",
  "Payroll Number": "Payroll Number",
  "Payroll Match": "Payroll Match",
  "Payroll History": "Payroll History",
  "Payroll PO": "Payroll PO",

  "Payable To": "Payable To",
  "Payables/Receivables": "Payables/Receivables",
  Paycheck: "Paycheck | Paychecks",
  "Paycheck Approved": "Paycheck Approved",

  paycheckAmountGap:
    "The paid amount differs from our calculated total by {delta}. This typically happens when a historical paycheck was reconciled against commissions that were still expected or against team/manager-share earnings that weren't captured.",
  "Clawback Applied": "Clawback Applied",
  paycheckClawback:
    "{amount} in commission was clawed back on this paycheck because one or more sales earned less than what was already advanced.",
  "Paycheck Override": "Paycheck Override",
  "Paycheck Override Confirmed": "Paycheck Override Confirmed",
  Paychecks: "Paychecks",
  Payment: "Payment | Payments",
  "Payment Received": "Payment Received",
  "Payment Terms": "Payment Terms",
  "Payment Type": "Payment Type",
  "Payments Received": "Payments Received",
  "Payroll Report": "Payroll Report",
  "Pencil Delivery": "Pencil Delivery",
  "Pencil Event": "Pencil Event",
  "Pencil Installation": "Pencil Installation",
  Pending: "Pending",
  "Pending approval": "Pending approval",
  "Pending change order": "Pending change order",
  "Pending Dates": "Pending Dates",
  "Pending items": "Pending items",
  "Pending override confirmation": "Pending override confirmation",
  "Pending Quotes": "Pending Quotes",
  "Pending sale": "Pending sale",
  "Pending Service Quotes": "Pending Service Quotes",
  "Per-item locations": "Per-item locations",
  "Percent of sale": "% of sale",
  Percentage: "Percentage",
  "Performance Metrics": "Performance Metrics",
  "Permanently deleted": "Permanently deleted",
  Person: "Person",
  "Person to meet on site": "Person to meet on site",
  Personal: "Personal",
  "Personal Residence": "Personal Residence",
  "Personal settings saved": "Personal settings saved",
  Phase: "Phase",
  Phone: "Phone",
  "Phone Number": "Phone Number | Phone Numbers",
  "Photo of Cash": "Photo of Cash",
  "Photo of Cheque": "Photo of Cheque",
  Photos: "Photos",
  "Photos/Videos": "Photos/Videos",
  "Pick Up From": "Pick Up From",
  "Picked Up": "Picked Up",
  "Picked up": "Picked up",
  "Pickup Complete": "Pickup Complete",
  "Pickup Location": "Pickup Location",
  "Pickups to Schedule": "Pickups to Schedule",
  "Pictures from Install": "Pictures from Install",
  Pinned: "Pinned",
  "Pinned entries appear at the top of their category":
    "Pinned entries appear at the top of their category",
  Pipeline: "Pipeline",
  "Plans/Specs": "Plans/Specs",
  "Please enter both start and end locations":
    "Please enter both start and end locations",
  "Please provide details about the problem...":
    "Please provide details about the problem...",
  "Please scan a location first": "Please scan a location first",
  PO: "PO",
  "PO ID": "PO ID",
  "PO Job": "PO Job",
  portal: {
    accountOverview: "Account overview",
    accountStatus: "Account Status",
    admin: "Admin",
    approvedQuotes: "No approved quotes | Approved quote | Approved quotes",
    balanceDue: "Balance due",
    companyAdmin: "Company Admin",
    contactUs: "Contact Us",
    contactUsSubtitle: "Have a question? Reach out below.",
    creditAppSubject: "Credit Application Request",
    creditApproved: "Approved",
    creditPending: "Pending approval",
    creditStatus: "Credit Status",
    history: "History",
    inactiveMessage:
      "Your account does not have an active credit application on file. Request one below to get started.",
    invoiceSummary: "Invoice Summary",
    members: "Members",
    membersSubtitle: "People in your organization with portal access.",
    noCompanyOnFile: "No company on file",
    noMembers: "No members found",
    openInvoiceCount: "Open invoices",
    openInvoices: "No open invoices | Open invoice | Open invoices",
    openInvoicesTab: "Open",
    openServices: "Open service requests",
    paidInvoiceCount: "Paid invoices",
    paidInvoicesTab: "Paid",
    quotesToReview: "No quotes to review | Quote to review | Quotes to review",
    requestCreditApp: "Request Credit Application",
    toReview: "To Review",
    viewInvoices: "View All Invoices",
    welcome: "Welcome, {name}",
    welcomeSubtitle:
      "Thank you for your business. Here is an overview of your account.",
    yourSalesRep: "Your Sales Representative",
    ytdSpending: "Spending this year (pre-tax)",
  },

  Position: "Position",
  "Possible Duplicates": "Possible Duplicates",
  "Poor Operation": "Poor Operation",
  "Postal Code": "Postal Code",
  "Pre-Approved": "Pre-Approved",
  "Pre-Tax": "Pre-Tax",
  Preset: "Preset | Presets",
  Pretax: "Pretax",
  Preview: "Preview",
  Previous: "Previous",
  "Previous Period": "Previous Period",
  "Previous Quote": "Previous Quote",
  "Previous Total": "Previous Total",
  "Previously Completed": "Previously Completed",
  "Previously Delivered": "Previously Delivered",
  Price: "Price",
  "Primary Location": "Primary Location",
  Print: "Print",
  "Print all": "Print all",
  "Print bins": "Print bins",
  "Print Quote": "Print Quote",
  Prize: "Prize",
  Product: "Product",
  "Product Information": "Product Information",
  "Product Lines": "Product Lines",
  "Product Type": "Product Type",
  Profit: "Profit",
  Progress: "Progress",
  Project: "Project | Projects",
  "Project email": "Project email",
  "Project ID": "Project ID",
  "Project Manager": "Project Manager",
  "Project Map": "Project Map",
  "Project Name": "Project Name",
  "Project Service": "Project Service",
  "Project/PO ID": "Project/PO ID",
  Protected: "Protected",
  "Protected Quote": "Protected Quote",
  Public: "Public",
  Published: "Published",
  "Punch list": "Punch list",
  "Punch list item": "Punch list item",
  Punchout: "Punchout",
  "Punchout Already Completed": "Punchout Already Completed",
  "Punchout Complete": "Punchout Complete",
  "Punchout complete": "Punchout complete",
  "Punchout Scheduled": "Punchout Scheduled",
  "Punchout scheduled": "Punchout scheduled",
  "Purchase Order": "Purchase Order | Purchase Orders",
  Purchaser: "Purchaser",
  Purpose: "Purpose",
  Push: "Push",
  "Push Notification": "Push Notification | Push Notifications",
  "Put On Hold": "Put On Hold",
  "QC Complete": "QC Complete",
  "Qc Inspected": "QC Inspected",
  Qty: "Qty", // Quantity
  "QC bypassed": "QC bypassed",
  Qualified: "Qualified",
  "Quality Control": "Quality Control",
  "Quality Control Complete": "Quality Control Complete",
  "Quality Control Report": "Quality Control Report",
  Quantity: "Quantity",
  "Quantity Delivered": "Quantity Delivered",
  "Quantity Discarded": "Quantity Discarded",
  "Quantity Donated": "Quantity Donated",
  "Quantity Installed": "Quantity Installed",
  "Quantity Invoiced": "Quantity Invoiced",
  "Quantity Ordered": "Quantity Ordered",
  "Quantity Ready": "Quantity Ready",
  "Quantity Repaired": "Quantity Repaired",
  "Quantity Scheduled": "Quantity Scheduled",
  "Quantity to Repair": "Quantity to Repair",
  Quarter: "Quarter",
  Queued: "Queued",
  Quote: "Quote | Quotes",
  "Quote approved": "Quote approved",
  "Quote Name": "Quote Name",
  "Quote PDF": "Quote PDF",
  "Quote Response": "Quote Response",
  "Quote sent": "Quote sent",
  "Quote/Order Parts": "Quote/Order Parts",
  Quotes: "Quotes",
  "Quotes Awaiting Response": "Quotes Awaiting Response",
  "Quotes Due": "Quotes Due",
  Rank: "Rank",
  "Rank By": "Rank By",
  Rate: "Rate",
  Reactivate: "Reactivate",
  "Read-only": "Read-only",
  "Read-only folder": "Read-only folder",
  Ready: "Ready",
  ready: "ready",
  "Ready for approval": "Ready for approval",
  "Ready for Pickup": "Ready for Pickup",
  "Ready for pickup": "Ready for pickup",
  "Ready for pickup or delivery": "Ready for pickup or delivery",
  "Ready for transit": "Ready for transit",
  "Ready to deliver": "Ready to deliver",
  "Ready to drive": "Ready to drive",
  "Ready to install": "Ready to install",
  "Ready to load": "Ready to load",
  "Ready to Order": "Ready to Order",
  "Ready to order": "Ready to order",
  "Ready to pay": "Ready to pay",
  "Ready to schedule": "Ready to schedule",
  "Ready to send": "Ready to send",
  Reason: "Reason",
  "Reason customer not present": "Reason customer not present",
  Reassign: "Reassign",
  "Reassign Sale": "Reassign Sale",
  "Reassign to Project": "Reassign to Project",
  Receipt: "Receipt | Receipts",
  "Receipt or Invoice": "Receipt or Invoice",
  "Receipt Photo": "Receipt Photo",
  Refund: "Refund | Refunds",
  Receive: "Receive",
  "Regular members": "Regular members",
  "Receive Down Payment": "Receive Down Payment",
  "Receive Payment": "Receive Payment",
  Received: "Received",
  "Received, not installed": "Received, not installed",
  received: "received",
  "Received By": "Received By",
  "Received Down Payment": "Received Down Payment",
  "Received From": "Received From",
  "Received items": "Received items",
  "Received Via": "Received Via",
  "Receiving/Delivery Notes": "Receiving/Delivery Notes",
  Receiving: "Receiving",
  "Receiving complete": "Receiving complete",
  "Receiving Dashboard": "Receiving Dashboard",
  "Receiving Mode": "Receiving Mode",
  Recent: "Recent",
  Recommended: "Recommended",
  Reconcile: "Reconcile",
  "Reconcile Commissions": "Reconcile Commissions",
  Referred: "Referred",
  "Referred Service": "Referred Service",
  "Referred To": "Referred To",
  Rejected: "Rejected",
  "Rejected by": "Rejected by",
  Refresh: "Refresh",
  "Regenerate PDF": "Regenerate PDF",
  Register: "Register",
  Release: "Release",
  "Release Hold": "Release Hold",
  Relocate: "Relocate",
  "Remaining amount to be collected": "Remaining amount to be collected",
  Reorder: "Reorder",
  "Remaining Items": "Remaining Items",
  remaining: "remaining",
  "Remaining to Pay": "Remaining to Pay",
  "Remind at": "Remind at",
  "Remind in": "Remind in",
  Reminder: "Reminder | Reminders",
  Remove: "Remove",
  "Remove Finance Charge": "Remove Finance Charge",
  "Remove from Topic": "Remove from Topic",
  "Remove Line Breaks": "Remove Line Breaks",
  Removed: "Removed",
  Rename: "Rename",
  "Renamed file": "Renamed file",
  Reopen: "Reopen",
  "Reopen Issue": "Reopen Issue",
  Repair: "Repair",
  Repaired: "Repaired",
  "Replace the existing files (they move to Trash)":
    "Replace the existing files (they move to Trash)",
  "Replacement Installation": "Replacement Installation",
  Reply: "Reply",
  "Reopen for Redelivery": "Reopen for Redelivery",
  "Reply All": "Reply All",
  Replying: "Replying",
  "Report an Issue": "Report an Issue",
  "Report Issue": "Report Issue",
  "Report New Issue": "Report New Issue",
  Reported: "Reported",
  "Reported → Resolved": "Reported → Resolved",
  "Reported → Reviewed": "Reported → Reviewed",
  "Reported Date": "Reported Date",
  "Reporting issue for": "Reporting issue for",
  "Request Changes": "Request Changes",
  "Request Company Account": "Request Company Account",
  "Request Final Quote": "Request Final Quote",
  "Request Update": "Request Update",
  Requested: "Requested",
  "Require Payment on Delivery": "Require Payment on Delivery",
  Required: "Required",
  required: "required",
  "Required for approval": "Required for approval",
  "Required Information": "Required Information",
  "Requires Another Visit": "Requires Another Visit",
  Reschedule: "Reschedule",
  "Resend Quote": "Resend Quote",
  Reset: "Reset",
  "Reset Password": "Reset Password",
  "Reset to Defaults": "Reset to Defaults",
  "Reset Zoom": "Reset Zoom",
  Residential: "Residential",
  "Residential: New Construction": "Residential — New Construction",
  "Residential: Remodel/Replace": "Residential — Remodel/Replace",
  Resolution: "Resolution",
  Resolve: "Resolve",
  "Resolve Issue": "Resolve Issue",
  "Resolve sale issues": "Resolve sale issue | Resolve sale issues",
  Resolved: "Resolved",
  Responded: "Responded",
  Restore: "Restore",
  "Restore Commission Schedule": "Restore Commission Schedule",
  "Restore this schedule": "Restore this schedule",
  "Restored file": "Restored file",
  Results: "Results",
  "Retail Price": "Retail Price",
  "Retail Price (Extended)": "Retail Price (Extended)",
  Retired: "Retired",
  Retry: "Retry",
  "Retry failed": "Retry failed",
  Revert: "Revert",
  Review: "Review",
  "Review Expense": "Review Expense",
  "Review Issue": "Review Issue",
  "Review Report": "Review Report",
  Reviewed: "Reviewed",
  "Reviewed & Ready to Schedule": "Reviewed & Ready to Schedule",
  "Reviewed By": "Reviewed By",
  "Reviewed by": "Reviewed by",
  Roles: "Roles",
  "Room, sub-location, or video chat link":
    "Room, sub-location, or video chat link",
  Route: "Route",
  Room: "Room",
  "Routing Number": "Routing Number",
  Safety: "Safety",
  Sale: "Sale | Sales",
  "Sale (Optional)": "Sale (Optional)",
  "Sale Canceled": "Sale Canceled",
  "Sale Issue": "Sale Issue | Sale Issues",
  "Sale Issues": "Sale Issues",
  "Sale Item": "Sale Item | Sale Items",
  "Sale Name": "Sale Name",
  "Sale not found": "Sale not found",
  "Sale Payment": "Sale Payment",
  Sales: "Sales",
  "Sales by Individual": "Sales by Individual",
  "Sales by Location": "Sales by Location",
  "Sales Count": "Sales Count",
  "Sales Games": "Sales Games",
  "Sales Goal": "Sales Goal",
  "Sales goal updated": "Sales goal updated",
  "Sales Goals": "Sales Goals",
  "Sales Lead": "Sales Lead | Sales Leads",
  "Sales Report": "Sales Report",
  "Select Contact": "Select Contact",
  "Select Office": "Select Office",
  "Sales Tools": "Sales Tools",
  "Upcoming Year": "Upcoming Year",
  "Sales Lead Discarded": "Sales Lead Discarded",
  "Sales Lead Lost": "Sales Lead Lost",
  "Sales Lead Referral": "Sales Lead Referral",
  "Sales Price": "Sales Price",
  "Sales Representative": "Sales Representative",
  "Sales Tax": "Sales Tax",
  "Sales Team": "Sales Team",
  "Sales Teams": "Sales Teams",
  SalesLeads: "Sales Leads",
  Salesperson: "Salesperson",
  Rotate: "Rotate",
  Save: "Save",
  "Save & Defer": "Save & Defer",
  "Save & Schedule": "Save & Schedule",
  "Save Progress": "Save Progress",
  "Save Signature": "Save Signature",
  "Save To": "Save To",
  "Scan Barcode": "Scan Barcode",
  Schedule: "Schedule",
  "Schedule Inspection": "Schedule Inspection",
  "Schedule Punchout": "Schedule Punchout",
  "Schedule Service": "Schedule Service",
  "Schedule Service Now": "Schedule Service Now",
  Scheduled: "Scheduled",
  scheduled: "scheduled",
  "Scheduled Date": "Scheduled Date",
  "Scheduled Deliveries": "Scheduled Deliveries",
  "Scheduled for service": "Scheduled for service",
  "Scheduled Installations": "Scheduled Installations",
  "Scheduled Materials/Labor": "Scheduled Materials/Labor",
  "Scheduled Pickups": "Scheduled Pickups",
  "Scheduled Services": "Scheduled Services",
  "Scheduled Unpaid Cash Sales": "Scheduled Unpaid Cash Sales",
  Scheduler: "Scheduler",
  Scheduling: "Scheduling",
  "Scheduling misc": "Scheduling screens/hardware",
  "Scope confirmed": "Scope confirmed",
  "Scan a location barcode to set": "Scan a location barcode to set",
  "Scan an item first": "Scan an item first",
  "Scan barcode": "Scan barcode",
  "Scan item": "Scan item",
  "Scan item barcode": "Scan item barcode",
  "Scan items": "Scan items",
  "Scan location": "Scan location",
  "Scan location barcode": "Scan location barcode",
  "Scan location to receive": "Scan location to receive",
  scanned: "scanned",
  "Scanned items": "Scanned items",
  Screen: "Screen | Screens",
  Screens: "Screens",
  "Screens & Hardware": "Screens & Hardware",
  "Screens and Hardware Included":
    "Screens and hardware to be delivered with product",
  "Scroll to Bottom": "Scroll to Bottom",
  "Scroll to Top": "Scroll to Top",
  "Seal Failure": "Seal Failure",
  Search: "Search",
  "Search All Contacts": "Search All Contacts",
  "Search by brand or series": "Search by brand or series",
  "Search by PO ID or Address": "Search by PO ID or Address",
  "Search PO, project, or location": "Search PO, project, or location",
  "Search projects": "Search projects",
  "Search projects, or paste a sale ID": "Search projects, or paste a sale ID",
  "Search...": "Search...",
  Section: "Section",
  Select: "Select",
  "Select a completion status": "Select a completion status",
  "Select a future date and time": "Select a future date and time",
  "Select a technician to view their availability.":
    "Select a technician to view their availability.",
  "Select All": "Select All",
  "Select all that apply": "Select all that apply",
  "Select an item to report an issue": "Select an item to report an issue",
  "Select date": "Select date",
  "Select File": "Select File",
  "Select Files": "Select Files",
  "Select from Open Service Issues": "Select from Open Service Issues",
  "Select Items": "Select Items",
  "Select items by category": "Select items by category",
  "Select Line Item (Optional)": "Select Line Item (Optional)",
  "Select location": "Select location",
  "Select Project": "Select Project",
  "Select Technician(s)": "Select Technician(s)",
  "Select item": "Select item",
  "Select location to receive": "Select location to receive",
  "Select packing slip document": "Select packing slip document",
  Selected: "Selected",
  Send: "Send",
  "Send Credit Memo": "Send Credit Memo",
  "Send Invoice": "Send Invoice",
  "Send Payroll Reminders": "Send Payroll Reminders",
  "Send Quote": "Send Quote",
  "Send to Client": "Send to Client",
  Sent: "Sent",
  Series: "Series",
  "Series Lead Time": "Series Lead Time | Series Lead Times",
  "Series-specific lead times": "Series-specific lead times",
  Service: "Service | Services",
  "Service Address": "Service Address",
  "Service Center": "Service Center",
  "Service Checklist": "Service Checklist",
  "Service complete": "Service complete",
  "Service Completed": "Service Completed",
  "Service Contact": "Service Contact",
  "Service Issue": "Service Issue | Service Issues",
  "Service Issue Parts": "Service Issue Parts",
  "Service Issue Pipeline": "Service Issue Pipeline",
  "Service Issues": "Service Issues",
  "Service Lead": "Service Lead | Service Leads",
  "Service Location": "Service Location",
  "Service Notes": "Service Notes",
  "Service Overview": "Service Overview",
  "Service Part": "Service Part | Service Parts",
  "Service Photos/Videos": "Service Photos/Videos",
  "Service Quote Created": "Service Quote Created",
  "Service Report": "Service Report",
  "Service Scheduled": "Service Scheduled",
  "Service scheduled": "Service scheduled",
  "Service Summary": "Service Summary",
  "Service Type": "Service Type",
  "Service Work Order": "Service Work Order",
  "Services to Schedule": "Services to Schedule",
  "Set to Paid in Full": "Set to Paid in Full",
  Settings: "Settings",
  "Settings saved successfully": "Settings saved successfully",
  Share: "Share",
  "Share of commission": "Share of commission",
  "Ship date": "Ship date",
  "Ship To": "Ship To",
  "Shop Drawings": "Shop Drawings",
  "Show Cost": "Show Cost",
  "Show On Hold": "Show On Hold",
  "Showing the first {n} issues — narrow the filter":
    "Showing the first {n} issues — narrow the filter",
  Signature: "Signature",
  "Signed By": "Signed By",
  "Signed Order": "Signed Order | Signed Orders",
  "Signer Name": "Signer Name",
  Signoff: "Signoff",
  since: "since",
  "Site Inspection": "Site Inspection",
  Skip: "Skip",
  "Skip the files that already exist": "Skip the files that already exist",
  Skipped: "Skipped",
  "Sliding Scale": "Sliding Scale",
  "SNA Archive": "SNA Archive",
  Sold: "Sold",
  "Sold By": "Sold By",
  "Sold Date": "Sold Date",
  "Sold To": "Sold To",
  "Sold to": "Sold to",
  Sort: "Sort",
  "Sort Order": "Sort Order",
  "Specific Issue": "Specific Issue",
  "Split Commission": "Split Commission",
  "Split from": "Split from",
  Square: "Square",
  Start: "Start",
  "Start Address": "Start Address",
  "Start Date": "Start Date",
  "Start Loading": "Start Loading",
  "Start Location": "Start Location",
  "Start Service": "Start Service",
  Started: "Started",
  "Start over": "Start over",
  "Starting Balance": "Starting Balance",
  Starts: "Starts", // e.g. "Event starts in 5 minutes"
  starts: "starts",
  State: "State",
  Status: "Status",
  Step: "Step",
  Stock: "Stock",
  "Stops Before Final Destination": "Stops Before Final Destination",
  "Stored Materials": "Stored Materials",
  Street: "Street",
  "Street Address": "Street Address",
  Subject: "Subject",
  Submit: "Submit",
  "Submit Expense": "Submit Expense",
  "Submit for Reimbursement": "Submit for Reimbursement",
  "Submit Issue": "Submit Issue",
  "Submit Pay App": "Submit Pay App",
  "Submit Payment": "Submit Payment",
  "Submit Report": "Submit Report",
  Submitted: "Submitted",
  "Submitted By": "Submitted By",
  "Submitted by": "Submitted by",
  "Submitted miles for reimbursement":
    "Submitted {miles} miles for reimbursement",
  Subtotal: "Subtotal",
  "Successfully sent email": "Successfully sent email",
  "Suggested: 3rd exterior photo and video for operational issues":
    "Suggested: 3rd exterior photo and video for operational issues",
  Summary: "Summary",
  "Symptoms/Description": "Symptoms/Description",
  Tags: "Tags",
  "Take Photo": "Take Photo",
  "Take Photo of Payment": "Take Photo of Payment",
  "Take photos of the part needed and the overall unit":
    "Take photos of the part needed and the overall unit",
  "Tap for directions": "Tap for directions",
  target: "target | targets",
  "Target Already Assigned": "Target Already Assigned",
  "Target Contact": "Target Contact | Target Contacts",
  Task: "Task | Tasks",
  "Task x completed": 'Task "{x}" completed',
  "Tax Exemption Certificate":
    "Tax Exemption Certificate | Tax Exemption Certificates",
  "Tax ID": "Tax ID",
  taxRateSet: "Tax rate set to {rate}%",
  Team: "Team",
  "Team created": "Team created",
  "Team deleted": "Team deleted",
  "Team Goal": "Team Goal",
  "Team Members": "Team Members",
  "Team Name": "Team Name",
  "Team Total": "Team Total",
  "Team updated": "Team updated",
  "Team's top 5 customers by pretax sales this year":
    "Team's top 5 customers by pretax sales this year",
  Tech: "Tech",
  "Tech Notes": "Tech Notes",
  Technician: "Technician | Technicians",
  Technicians: "Technicians",
  "Tell me when it's closed": "Tell me when it's closed",
  "Temporarily Delivered": "Temporarily Delivered",
  "Temporary Delivery": "Temporary Delivery",
  "Temporary Delivery Complete": "Temporary Delivery Complete",
  "Temporary Destination": "Temporary Destination",
  Terms: "Terms",
  Theme: "Theme",
  "These issues cannot be completed until parts are received.":
    "These issues cannot be completed until parts are received.",
  "These issues need parts, a quote, or another visit and will remain open.":
    "These issues need parts, a quote, or another visit and will remain open.",
  "These issues were discovered during the service visit and will require additional attention.":
    "These issues were discovered during the service visit and will require additional attention.",
  "Third-Party Items Only": "Only items sold by others",
  "Verify Payment": "Verify Payment",
  "Thank you!": "Thank you!",
  "This contact": "This contact",
  "This helps with scheduling and resource allocation.":
    "This helps with scheduling and resource allocation.",
  "This is a cash sale customer. Collect payment before leaving.":
    "This is a cash sale customer. Collect payment before leaving.",
  "this week": "this week",
  Time: "Time",
  "Time (Optional)": "Time (Optional)",
  "Time Clock": "Time Clock",
  "Time Slot": "Time Slot | Time Slots",

  Theirs: "Theirs",
  "Time Zone": "Time Zone | Time Zones",
  Timeline: "Timeline",
  Tip: "Tip",
  "Tips & Tricks": "Tips & Tricks",
  Title: "Title",
  To: "To",
  to: "to",
  "To Held": "To Held",
  "To load": "To load",
  "To repair": "To repair",
  Today: "Today",
  today: "today",
  "Today's Agenda": "Today's Agenda",
  tomorrow: "tomorrow",
  "Tomorrow's Agenda": "Tomorrow's Agenda",
  "Too Short": "Too Short",
  "Top Customers": "Top Customers",
  "Topic Color": "Topic Color",
  Total: "Total | Totals",
  "Total Commission": "Total Commission",
  "Total Cost": "Total Cost",
  "Total Invoiced": "Total Invoiced",
  "Total Margin": "Total Margin",
  "Total Miles": "Total Miles",
  "Total payments applied to invoices": "Total payments applied to invoices",
  "Total Sales": "Total Sales",
  "Total Sales YTD": "Total Sales YTD",
  "Total Signed": "Total Signed",
  Transaction: "Transaction | Transactions",
  "Transaction Type": "Transaction Type",
  Trash: "Trash",
  "Trash is empty": "Trash is empty",
  trashRetention:
    "Files in Trash are permanently deleted 30 days after removal. Admins and the original user can restore files during that window.",
  "Triage Actions": "Triage Actions",
  Troubleshooting: "Troubleshooting",
  Truck: "Truck",
  Type: "Type",
  Typical: "Typical",
  "Un-Maximize": "Un-Maximize",
  "Un-void Invoice": "Un-void Invoice",
  Unarchive: "Unarchive",
  Unassigned: "Unassigned",
  "Uncheck all findings (Parts, Quote, Another Visit) to resolve":
    "Uncheck all findings (Parts, Quote, Another Visit) to resolve",
  "Uncheck all findings first": "Uncheck all findings first",
  Undelivered: "Undelivered",
  Unknown: "Unknown",
  "Unloading from truck": "Unloading from truck",
  "Unloading Started": "Unloading Started",
  Unlock: "Unlock",
  "Unsaved Changes": "Unsaved Changes",
  Undo: "Undo",
  "Undo delivery": "Undo delivery",
  "Undetermined lead time":
    "Undetermined lead time; please verify before ordering",
  Unit: "Unit | Units",
  "Unknown Project": "Unknown Project",
  Unlimited: "Unlimited",
  Unload: "Unload",
  "Unmatched Emails": "Unmatched Emails",
  Unpaid: "Unpaid",
  "Unpaid Miles": "Unpaid Miles",
  "Unpublished entries are only visible to editors":
    "Unpublished entries are only visible to editors",
  "Unresolved Sale Issues": "Unresolved Sale Issue(s)",
  "Unresolved sale issues": "Unresolved sale issue(s)",
  "Upcoming Installations": "Upcoming Installations",
  Update: "Update",
  "Updated quote requested": "Updated quote requested",
  "Updating x references": "Updating 1 reference | Updating {count} references",
  Upload: "Upload",
  "Upload File": "Upload File",
  "Upload Files": "Upload Files",
  "Upload Folder": "Upload Folder",
  Uploaded: "Uploaded",
  "Uploaded file": "Uploaded file",
  Uploading: "Uploading",
  "Uploading PDF...": "Uploading PDF...",
  upToFolder: "Up to {name}",
  Urgency: "Urgency",
  Urgent: "Urgent",
  "Urgent Only": "Urgent Only",
  "Urgent Service Hot List": "Urgent Service Hot List",
  "Use Margin": "Use Margin",
  "Use theirs": "Use theirs",
  "Use this contact": "Use this contact",
  "Use Markup": "Use Markup",
  "Use Project Address": "Use Project Address",
  "Use previous location": "Use previous location",
  "Use previous locations": "Use previous locations",
  User: "User | Users",
  "User account": "User account",
  "User Settings": "User Settings",
  "Vector Overlap": "Vector Overlap",
  Vehicle: "Vehicle | Vehicles",
  "Vehicle arrived": "Vehicle arrived",
  Vendor: "Vendor | Vendors",
  "Vendor Account Document":
    "Vendor Account Document | Vendor Account Documents",
  "Vendor Case": "Vendor Case",
  "Vendor Case Number": "Vendor Case Number",
  "Vendor Cases to Close": "Vendor Cases to Close",
  "Vendor Credit": "Vendor Credit | Vendor Credits",
  "Vendor Credit Memo": "Vendor Credit Memo",
  "Vendor Invoice Number": "Vendor Invoice Number",
  "Vendor Order Number": "Vendor Order Number",
  "Vendor Quote Numbers": "Vendor Quote Numbers",
  Verify: "Verify",
  "Verify Email": "Verify Email",
  via: "via",
  Video: "Video",
  "Video Embed Code": "Video Embed Code",
  "Video URL": "Video URL",
  View: "View",
  "View all": "View all",
  "View As": "View as…",
  "View Details": "View Details",
  "View details": "View details",
  "View Expense": "View Expense",
  "View inventory item": "View inventory item",
  "View Invoices": "View Invoices",
  "View Map": "View Map",
  "View Payments": "View Payments",
  "View PDF": "View PDF",
  "View Pending Paycheck": "View Pending Paycheck",
  "View Quote": "View Quote",
  "View Report": "View Report",
  "View Route": "View Route",
  "View Sale": "View Sale",
  "View Work Order": "View Work Order",
  Views: "Views",
  views: "views",
  "Visible only to you; 1 GB cap": "Visible only to you; 1 GB cap",
  Void: "Void",
  "Void Invoice": "Void Invoice",
  "Void Paycheck": "Void Paycheck",
  Voided: "Voided",
  vs: "vs",
  W9: "W-9",
  "waiting on parts": "waiting on parts",
  Warehouse: "Warehouse",
  Warehouses: "Warehouses",
  "Warehouse Location": "Warehouse Location",
  Warnings: "Warnings",
  Warranty: "Warranty",
  "Warranty (parts + labor)": "Warranty (parts + labor)",
  "Warranty (parts only)": "Warranty (parts only)",
  "Warranty covers both parts and labor":
    "Warranty covers both parts and labor",
  "Warranty covers both parts and labor. No customer quote needed.":
    "Warranty covers both parts and labor. No customer quote needed.",
  "Warranty Order Documents": "Warranty Order Documents",
  "Was this helpful?": "Was this helpful?",
  "Watch Video": "Watch Video",
  "We will contact you to schedule a follow-up appointment for the remaining items.":
    "We will contact you to schedule a follow-up appointment for the remaining items.",
  Week: "Week | Weeks",
  weeks: "{count} week | {count} weeks",
  weeksRange: "{min}-{max} weeks",
  "What is the urgency level?": "What is the urgency level?",
  "What type of issue?": "What type of issue?",
  "What type of parts?": "What type of parts?",
  "What's Next?": "What's Next?",
  When: "When",
  "Which sale is it for?": "Which sale is it for?",
  "Why can't this issue be scheduled yet?":
    "Why can't this issue be scheduled yet?",
  "Will be completed at punchout": "Will be completed at punchout",
  Windows: "Windows",
  "Who is borrowing this sample?": "Who is borrowing this sample?",
  Wholesale: "Wholesale",
  "Wholesale Account": "Wholesale Account",
  "Wholesale Location": "Wholesale Location",
  with: "with",
  "With Balance": "With Balance",
  "Withdrawn for paycheck": "Withdrawn for paycheck",
  Work: "Work",
  "Work Order Details": "Work Order Details",
  "Work order dialog will open after saving.":
    "Work order dialog will open after saving.",
  "Work Order Not Found": "Work Order Not Found",
  "Work Orders": "Work Orders",
  "Work to Complete": "Work to Complete",
  "Workers Comp": "Workers' Compensation",
  "x merges into y": "{from} merges into {to}",
  Year: "Year",
  Yes: "Yes",
  "Yes, third-party": "Yes, third-party",
  yesterday: "yesterday",
  "You are logged in as an employee": "You are logged in as an employee",
  YTD: "YTD",
  Yours: "Yours",
  "Your Contribution": "Your Contribution",
  "Your top 5 customers by pretax sales this year":
    "Your top 5 customers by pretax sales this year",
  "YouTube, Vimeo, or other video link": "YouTube, Vimeo, or other video link",
  Zip: "Zip",
  Zone: "Zone | Zones",
  "Zoom In": "Zoom In",
  "Zoom Out": "Zoom Out",
  "Zoom Fit": "Zoom Fit",

  // Warehouse maps (admin editor)
  "Add Zone": "Add Zone",
  "Bin count": "Bin count",
  "Cannot delete warehouse": "Cannot delete warehouse",
  "Cannot delete zone": "Cannot delete zone",
  Colour: "Colour",
  "Default receiving map": "Default receiving map",
  "Delete Feature": "Delete Feature",
  Feature: "Feature",
  "Grid size": "Grid size",
  "Has bins": "Has bins",
  Height: "Height",
  "New Warehouse": "New Warehouse",
  "New warehouse map": "New warehouse map",
  Polygon: "Polygon",
  Rectangle: "Rectangle",
  "Remove vertex": "Remove vertex",
  "Rename occupied zone?": "Rename occupied zone?",
  "Set as default": "Set as default",
  Redo: "Redo",
  "Snap to grid": "Snap to grid",
  "Unnamed zone": "Unnamed zone",
  "Warehouse Map": "Warehouse Map | Warehouse Maps",
  Width: "Width",
  Transfer: "Transfer | Transfers",
  transferSummary: "{items} item(s), {units} unit(s) selected",

  import: {
    uploading: "Uploading PDF...",
    extracting: "Extracting images...",
    analyzing: "Analyzing with AI...",
    uploaded: "PDF uploaded",
  },

  confirm: {
    deleteWarehouse:
      "Delete the warehouse map {name}? This permanently removes its layout and zones.",
    deleteZone:
      "Delete zone {zone}? This removes it from the warehouse layout.",
    deleteOccupiedZone:
      "Zone {zone} still holds {count} item(s). Delete it anyway? Those items will point to a zone that isn't on the map until it is recreated.",
    renameOccupiedZone:
      "These zones hold inventory and renaming them will orphan the existing item locations: {zones}. Rename anyway?",
    "reopen-redelivery":
      "Re-open this item so a replacement can be delivered? This reverses the recorded delivery for it.",
    sampleReadyForPickup:
      "Let us know you're ready for us to pick up this sample?",
    "add-newly-ready-items":
      "These items are now ready but aren't on this delivery. Add them so they can be loaded?",
    "add-to-company":
      "Are you sure you want to make this contact an employee of {company}?",
    "apply-to-all-items": "Apply to all items?",
    "begin-transit": "Begin transit? This will notify the customer.",
    "begin-transit-no-notify": "Begin transit?",
    "bypass-qc":
      "Are you sure you want to bypass QC for this packing slip? A service lead will be created for post-delivery inspection.",
    "cancel-loading":
      "Cancel loading? This will return the delivery to the 'ready to load' state.",
    "cancel-sale": "Are you sure you want to cancel this sale?",
    "cancel-work-order":
      "Are you sure you want to cancel this scheduled work order? The calendar event will be removed.",
    "close-out-legacy-punchout":
      "Mark this sale's punchout complete without scheduling a service visit? Only for a punchout that was done before the Service Center existed. Any screens or hardware still counted as in stock will be marked delivered, and no one is notified.",
    "clear-all-scans": "Clear all scanned items?",
    "clear-all-series": "Would you like to clear the series of all items?",
    "overwrite-remote-changes":
      "Someone else also changed {fields} while you were editing. Saving now replaces their values with yours. Continue?",
    "commission-mark-paid":
      "This will permanently mark {count} commission(s) as paid. This cannot be undone.",
    "commission-reconcile":
      "This will mark {count} matched commission(s) as paid based on payroll history. This cannot be undone.",
    "commission-scheduled-change":
      "The commission schedule has changed. Please specify the effective date for the new schedule. Sales before this date will use the previous schedule.",
    "complete-loading": "Finish loading? This will notify the customer.",
    "complete-loading-no-notify": "Finish loading?",
    "complete-with-unchecked-checklist":
      "{count} checklist item isn't ticked. Complete the service anyway? | {count} checklist items aren't ticked. Complete the service anyway?",
    "contact-match":
      "{name} has already been entered. Would you like to edit that contact?",
    "contract-quote-total-mismatch":
      "The contract total does not equal the quote total. Would you like to continue anyway?",
    "customer-pickup": "Are you sure you want to mark this sale as picked up?",
    "decline-quote":
      "If you wouldn't mind providing a little feedback, may we ask the reason for declining?",
    "defer-ordering-always":
      "Defer ordering to purchasers on all your sales from now on, or just this time?",
    "defer-ordering-always-for":
      "Defer ordering to purchasers on all of {name}'s sales from now on, or just this time?",
    "defer-ordering-never":
      "Stop deferring ordering to purchasers on your sales from now on, or just this time?",
    "defer-ordering-never-for":
      "Stop deferring ordering to purchasers on {name}'s sales from now on, or just this time?",
    "delete-ack": "Are you sure you want to delete this acknowledgement?",
    "delete-bill": "Are you sure you want to delete this bill?",
    "delete-credit-memo": "Are you sure you want to delete this credit memo?",
    "delete-entry": "Are you sure you want to delete this entry?",
    "delete-event": "Are you sure you want to delete this event?",
    "delete-expense": "Are you sure you want to delete this expense?",
    "delete-feedback": "Are you sure you want to delete this feedback?",
    "delete-file": "Are you sure you want to delete {name}?",
    "delete-game": "Are you sure you want to delete this game?",
    "delete-inventory-item":
      "Are you sure you want to delete this inventory item?",
    "delete-invoice": "Are you sure you want to delete this invoice?",
    "delete-lead": "Are you sure you want to delete this lead?",
    "delete-log": "Are you sure you want to delete this log?",
    void: "Are you sure you want to void this?",
    "delete-issue": "Are you sure you want to delete this issue?",
    "delete-sale-issue": "Are you sure you want to delete this sale issue?",
    "delete-knowledge-base-entry":
      "Are you sure you want to delete this knowledge base entry?",
    "delete-lead-time": "Are you sure you want to delete this lead time?",
    "delete-library-file":
      "This file will be moved to Trash. Admins or you can restore it within 30 days, after which it will be permanently deleted.",
    "delete-library-folder":
      "Are you sure you want to delete this folder and everything inside it? Files inside will be moved to Trash and can be restored within 30 days.",
    "delete-mileage-rate": "Are you sure you want to delete this mileage rate?",
    "delete-message": "Are you sure you want to delete this message?",
    "delete-order": "Are you sure you want to delete this order?",
    "delete-other-ack": "Are you sure you want to delete this acknowledgement?",
    "delete-packing-slip": "Are you sure you want to delete this packing slip?",
    "delete-project": "Are you sure you want to delete this project?",
    "delete-quote": "Are you sure you want to delete this quote?",
    "cancel-receiving-session":
      "Cancel this receiving session? Nothing has been scanned into it, so nothing received is lost.",
    "delete-receiving-session":
      "Delete this receiving session? Nothing has been scanned into it, so nothing received is lost.",
    "delete-sale-item": "Are you sure you want to delete this item?",
    "delete-task": "Are you sure you want to delete this task?",
    "delete-team": "Are you sure you want to delete this sales team?",
    "delete-topic":
      "Are you sure you want to delete this topic? Its messages stay, unfiled.",
    "delete-tx": "Are you sure you want to delete this transaction?",
    "delete-unmatched-email":
      "Are you sure you want to delete this unmatched email? This cannot be undone.",
    "delete-vehicle": "Are you sure you want to delete this vehicle?",
    "delete-vendor-credit":
      "Are you sure you want to delete this vendor credit?",
    "delete-work-order": "Are you sure you want to delete this work order?",
    "disable-user": "Are you sure you want to deactivate this account?",
    "discard-change-order":
      "The selected quote is the original quote. Discard change order?",
    "discard-changes": "Are you sure you want to discard your unsaved changes?",
    "held-pay-adjust":
      "{direction} {employee}'s held pay by {amount}? New balance: {newBalance}.",
    "receiving-session-has-scans":
      "{count} package(s) have been scanned into this session, and each one told the vendor's records it arrived. Take those scans back off, or keep them and finish receiving this truck so the packing slips are created?",
    "relocate-loaded-item":
      "This item is loaded on a truck for an active delivery ({events}). Relocating it here leaves that delivery's loaded items out of sync; unload the truck from the delivery instead. Relocate anyway?",
    "review-expense":
      "Are you sure you want to approve and mark this expense as reviewed?",
    "delete-cost": "Are you sure you want to delete this cost?",
    "save-before-navigate":
      "You have unsaved changes. Would you like to save them before continuing?",
    "down-payment-requested":
      "Are you sure you want to mark this down payment as requested?",
    "assess-finance-charge":
      "Assess a late-payment finance charge on this invoice? It accrues daily at {rate} per month on the outstanding balance from the date below (by default {days} days after the invoice date), and can be removed at any time.",
    "remove-finance-charge":
      "Remove the finance charge from this invoice? The accrued charge will be reversed off the balance.",
    "notify-finance-charge":
      "Send the customer a notice that a finance charge has been assessed on this invoice?",
    "duplicate-quote-sales-lead":
      "This will duplicate the sales lead as well. Are you sure you want to continue?",
    "duplicate-quote-project":
      "This will create a new sales lead, not attached to a project. A new project will be created when the quote is sold. Are you sure you want to continue?",
    "email-receipt": "Would you like to email a receipt to {email}?",
    "enable-user": "Are you sure you want to reactivate this account?",
    "end-transit": "End transit? This will notify the customer.",
    "end-transit-no-notify": "End transit?",
    "exceed-credit-limit":
      "This sale exceeds the customer's credit limit by {exceedsBy}. Proceed anyway?",
    "exit-receiving-mode":
      "You have received items. Are you sure you want to exit without completing?",
    "expect-po-contract": "I will be providing a Purchase Order or Contract",
    "final-delivery":
      "The destination does not match the sale ship-to address. Are you sure this is a final delivery?",
    "followup-invoice":
      "Are you sure you want to send the customer another email about this invoice?",
    "followup-quote":
      "Are you sure you want to send the customer another email about this quote?",
    "incomplete-loading":
      "Some items have not been loaded. Finish loading anyway? This will notify the customer.",
    "incomplete-loading-no-notify":
      "Some items have not been loaded. Finish loading anyway?",
    "incomplete-receiving":
      "{received} items received, {pending} items still pending. Mark pending items as backordered?",
    "load-to-scheduled-truck":
      "This truck already has a delivery scheduled. Loading items here may cause scheduling conflicts. Are you sure you want to continue?",
    "legal-signature":
      "A signature of approval or electronic acceptance is required to finalize the order. This signed order then becomes the contract and is binding.",
    "legal-signature-delivery":
      "By signing here, I am stating that {company} was on site and delivered material. Sizes, quantities, specifications, damages, etc. were not inspected at the time of delivery, but is understood that there are 48 hours from the time of this delivery to report any issues to {company}.",
    "legal-signature-installation":
      "By signing here, I am stating that {company} was on site and completed the installation of the materials. It is understood that there are 48 hours from the time of this installation to report any issues to {company}.",
    "library-duplicate-files":
      "1 file you are uploading already exists in its folder. | {count} files you are uploading already exist in their folders.",
    "mark-fully-received":
      "Are you sure you want to mark this order and all its acknowledgements as fully received? This should not be used to bypass the receiving process.",
    "mark-not-received":
      "Are you sure you want to clear the fully received override on this order and all its acknowledgements? Receipt will revert to being based on received item quantities.",
    "ignore-duplicates": "Mark these contacts as false duplicates?",
    "merge-duplicates": "Merge duplicates? This cannot be undone.",
    "new-invoice": "Generate new invoice?",
    "new-role-widgets":
      "You have been assigned the {roles} role. Would you like to add the recommended dashboard widgets for this role?",
    "lead-match":
      "This lead's address matches an existing lead. Would you like to edit that one instead?",
    "print-location-label": "Print the label for {location}?",
    "print-location-labels": "Print {count} label? | Print {count} labels?",
    "project-match": "Associate this lead with existing project {address}?",
    "purge-library-file":
      "Permanently delete this file? This cannot be undone.",
    "replace-file": 'Would you like to replace the existing file "{name}"?',
    "reset-form": "Are you sure you want to reset the form?",
    "reset-notifications":
      "Are you sure you want to reset notification settings to defaults?",
    "reset-password":
      "Are you sure you want to reset the password for {email}?",
    "reset-terms": "Are you sure you want to discard the custom terms?",
    "restore-commission-schedule":
      "This will restore the selected commission schedule. You will be prompted for an effective date when you save.",
    "restore-library-file":
      "Restore this file from Trash? It will go back to its folder.",
    "revert-change": "Are you sure you want to revert this change?",
    "review-ack":
      "Are you sure you want to mark this acknowledgement as reviewed?",
    "save-continue": "Would you like to save your changes and continue?",
    "schedule-delivery":
      "Some items have not been scheduled for delivery. Would you like to schedule a delivery now?",
    "schedule-delivery-another":
      "Some items have not been scheduled for delivery. Would you like to schedule another delivery now?",
    "schedule-install":
      "This sale includes installed items. Would you like to schedule an installation now?",
    // "schedule-install-another":
    //   "This sale requires more installation hours. Would you like to schedule another installation now?",
    "schedule-install-hours":
      "This installation requires more hours. Are you sure you want to continue?",
    "schedule-sibling-sales":
      "No other sales have items ready for delivery. | Sale {sales} also has items ready for delivery. Include it on this delivery? | {count} other sales have items ready for delivery: {sales}. Include them on this delivery?",
    "send-customer-emails": "Are you sure you want to email the customer(s)?",
    "send-credit-memo":
      "Are you sure you want to send the customer a copy of this credit memo?",
    "send-invoice":
      "Are you sure you want to send the customer a copy of this invoice?",
    "send-quote":
      "Are you sure you want to send the customer a copy of this quote?",
    "set-all-series":
      'Would you like to set the series of all items to "{series}"?',
    "fill-empty-series":
      'Would you like to fill all empty series fields with "{series}"?',
    "start-loading": "Begin loading? This will notify the customer.",
    "start-loading-no-notify": "Begin loading?",
    "submit-report":
      "Are you sure you want to submit the report? This will invoice and notify the customer.",
    "submit-report-invoice":
      "Are you sure you want to submit the report? This will generate an invoice.",
    "submit-paycheck":
      "Are you sure you want to submit the paycheck for approval?",
    "submit-report-no-notify": "Are you sure you want to submit the report?",
    "complete-pickup":
      "Are you sure you want to complete this pickup? This will generate an invoice.",
    "complete-pickup-no-notify":
      "Are you sure you want to complete this pickup?",
    "tax-exempt-certificate":
      "A tax exempt certificate is required to finalize the sale.",
    "third-party-items":
      "This quote sells labor against third-party items only. Are these goods supplied by another vendor? If they were previously sold to this project on another sale, cancel and add those line items to the labor instead so we can schedule, install and bill them normally.",
    "undo-delivery":
      "Undo this delivery? The items go back on the truck and the sale's delivered counts are reversed. The customer has already been notified, and the signature, proof photos and report are kept on file but removed from this delivery.",
    "updated-original":
      "The original has been updated. Would you like to abandon your changes?",
    "user-match": "Edit existing user {name}?",
    "void-invoice":
      "Are you sure you want to void this invoice? The customer will be notified.",
    "void-paycheck":
      "Are you sure you want to void this paycheck? The selected commissions will be returned to Ready for approval.",
  },

  reconcile: {
    "not-ready-tooltip":
      'Commission must be marked "Ready for approval" or "Approved" before it can be reconciled.',
    "strong-match": "Strong Match",
    "likely-match": "Likely Match",
    "weak-match": "Weak Match",
  },

  error: {
    // Validation errors
    addressesInvalid: "All addresses must be valid",
    warehouseOccupied:
      "This warehouse has zones holding inventory ({zones}). Move it before deleting the map.",
    zonesOverlap:
      "Zones overlap. Fix the zones shown in red, or keep the map as a draft.",
    zonesOverlapNamed:
      "These zones overlap: {zones}. Fix them before activating the map.",
    amountInvalid: "Amount must be a valid number",
    amountRequired: "Amount must be a positive number",
    binRequired: "Bin is required",
    binWholeNumber: "Bin must be a whole number",
    dateInvalid: "Invalid date",
    dateRangeInvalid: "To must not be before From",
    discountPercentInvalid: "Discount must be between 0 and 100",
    duplicateZoneLabel: "Zone labels must be unique",
    invalidMapSvg: "Map SVG must define at least one zone",
    invalidWarehouseName:
      "Warehouse names can't be blank or contain '/', ':' or ','",
    invalidZoneLabel:
      "Zone labels must be non-empty and may not contain ':' or ','",
    notAllCaps: "Should not be all caps",
    otherAckNumber: "Enter the PO or the vendor's order number",
    phonesInvalid: "All phone numbers must be valid",
    quantityPositive: "Quantity must be greater than zero",
    reasonRequiredMissingDocument:
      "A reason is required when document is missing",
    required: "Required",
    savingEntry: "Error saving entry",
    totalCostInvalid: "Total cost must be a valid amount",
    transferIncomplete: "Select items and a different destination location",
    typeInvalid: "Invalid type",
    unnamedZone: "Name every zone before saving",

    // Additional validation errors
    allItemsMustBeCompleted: "All items must be completed",
    allItemsMustHaveValidDestination: "All items must have a valid destination",
    allMembersMustBeAssigned: "All members must be assigned",
    atLeastOneRecipientRequired: "At least one recipient is required",
    atLeastOneItemMustBeChecked: "At least one item must be checked",
    fromLocationQuantitiesMustMatch: "From location quantities must match",
    itemLoadedOnTruck:
      "This item is loaded on a truck for an active delivery ({events}). Unload the truck from the delivery instead of relocating the item here.",
    laborHoursMustMatchTotal: "Labor hours must match the total",
    locationQuantitiesMustMatchRemaining:
      "Location quantities must match remaining quantity",
    paymentOrSignatureOverrideRequired:
      "Payment or signature override is required",
    validDocumentRequired: "A valid document is required",
    validLocationRequired: "A valid location is required",
    pdfMustBeGenerated: "PDF must be generated",
    pleaseSelectValidContact: "Please select a valid contact",
    pleaseSelectOffice: "Please select an office",
    poIdNotFound: "PO ID not found",
    regularMemberPercentagesTotal100:
      "Regular member percentages should total 100%",
    reopenRedeliveryInstalled:
      "This item is already installed. Un-install it before re-opening it for redelivery.",
    reopenRedeliveryNoPriorLocation:
      "No warehouse location to return this item to. Receive the replacement through QC instead.",
    reopenRedeliveryNotDelivered:
      "This item has not been delivered, so there is nothing to re-open.",
    reportLocked: "Report is locked",
    toLocationQuantitiesMustMatch: "To location quantities must match",

    // Account
    accountTypeInvalid: "Invalid account type",
    ccExpInvalid: "Invalid expiration date",

    // Ack
    ackHasPaidBills:
      "This acknowledgement has bills with payments on them. An admin will need to delete each payment from the bill, then delete the bills, before this acknowledgement can be deleted.",
    ackHasQcdPackingSlips:
      "This acknowledgement has packing slips that have already been QC'd. QC'd packing slips can't be deleted yet; please ask a developer for help.",
    ackHasFinalizedChildren:
      "This acknowledgement has bills with payments and packing slips that have been QC'd. An admin will need to delete each payment from the bill and then delete the bills. QC'd packing slips can't be deleted yet; please ask a developer for help.",

    // Bill
    billHasPayments:
      "This bill has payments on it and can't be deleted. An admin will need to delete each payment from the bill first, then try again.",

    // CalendarEvent
    eventTypeInvalid: "Invalid event type",
    endAfterStart: "End must be after start",
    atLeastOneInstanceRequired: "At least one instance is required",

    // Commission
    approvedExceedsMargin: "Approved amount cannot exceed actual margin",
    splitPercentInvalid: "Invalid percentage",

    // CallLog

    // MileageLog
    milesPositive: "Miles must be greater than zero",
    ratePositive: "Rate must be greater than zero",
    routeLocationsRequired: "Please enter both start and end locations.",
    routeLookupFailed:
      "The distance between those places could not be worked out. Check both addresses and try again.",
    calculateRouteFirst: "Please calculate the route first",

    // Contact
    mergeRejected:
      "1 group could not be merged | {count} groups could not be merged",

    // CreditMemo

    // Expense

    // InventoryItem
    quantityToRepairExceeds: "Quantity to repair exceeds available",
    quantityRepairedExceeds: "Quantity repaired exceeds available",
    quantityDiscardedExceeds: "Quantity discarded exceeds available",
    quantityDonatedExceeds: "Quantity donated exceeds available",
    reasonRequiredDiscarding: "A reason is required when discarding items",

    // Invoice

    // Issue
    quantityInvalid: "Invalid quantity",

    // LeadTime
    valueNonNegative: "Value must not be negative",
    maxWeeksMinimum: "Max weeks must be at least min weeks",
    duplicateSeriesName: "Duplicate series name",

    // Library
    fileNameInvalid: "File name cannot contain slashes",
    folderNameInvalid: "Folder name cannot contain slashes",
    libraryFileNotFound: "File not found",
    libraryFolderNotFound: "Folder not found",
    libraryFolderReadOnly:
      "This folder is read-only. Only an administrator can change it.",
    libraryMoveCrossTier:
      "Files and folders cannot be moved to a different access level",
    libraryMoveIntoSelf:
      "A folder cannot be moved into itself or one of its own subfolders",
    libraryNotPermitted:
      "You do not have permission to do that in the Document Library",
    libraryRetryFolderDeleted:
      "{names} can't be uploaded again: its folder has been deleted. Upload it to a different folder. | {count} files can't be uploaded again because their folder has been deleted: {names}. Upload them to a different folder.",
    personalLibraryQuotaExceeded:
      "Your personal Document Library is full. Delete old or unused files to make room.",

    // Order
    manHoursPositive: "Man hours must be greater than zero",

    // PackingSlip
    documentAnalysisFailed:
      "Failed to analyze document. Please try again or use a different file format.",
    documentProcessTimeout:
      "The document took too long to process. Try with a smaller file or fewer pages.",
    documentTooLarge:
      "The document is too large or the service is busy. Please try again.",
    itemLocationsRequired: "Item locations are required",
    packingSlipExtractFailed: "Failed to extract packing slip data",
    packingSlipQcInspected:
      "This packing slip has already been QC'd and can't be deleted yet — please ask a developer for help.",
    hardwareInvalid:
      "All hardware items must have valid descriptions and locations",
    screensInvalid:
      "All screen items must have valid descriptions and locations",

    // Paycheck
    advanceExceedsExpected:
      "Advance exceeds the expected commission still to be paid on this sale ({amount} available)",
    holdDrawConflict: "Cannot hold and draw/use held funds at the same time",
    holdExceedsCommission: "Amount to hold exceeds commission",
    negativePaycheckTotal:
      "This paycheck totals less than $0 and cannot be paid. Remove the clawed-back commission and recover it through held pay instead.",
    fromHeldExceeds: "Amount from held exceeds available held funds",
    drawExceedsAllowed: "Draw amount exceeds allowed draw",
    overrideCommissionNegative: "Override commission must not be negative",
    overrideHoldExceedsCommission: "Override amount to hold exceeds commission",
    paycheckOverridePending:
      "This employee's pending paycheck is awaiting override confirmation, so nothing can be added to it until that is confirmed.",

    // Project

    // Receiving
    cameraAccessFailed: "Could not access camera",
    cameraNotFound: "No camera found",
    issueNeedsPO:
      "Assign this package to a PO first — a sale issue is opened against that PO's sale.",
    locationCodeInvalid: "Invalid location code",
    sessionHasScans:
      "This session has packages scanned into it. Undo those scans from the scanning screen first — each one also marked the vendor's package received.",

    // SaleItem
    readyExceedsTotal: "Ready quantity exceeds total",
    scheduledExceedsTotal: "Scheduled quantity exceeds total",
    invoicedExceedsTotal: "Invoiced quantity exceeds total",

    // SalesGame
    themeInvalid: "Invalid theme",
    rankByInvalid: "Invalid rank by",
    goalTypeInvalid: "Invalid goal type",

    // SalesLead

    // SalesLeadStatus

    // SalesLeadOutcome
    intentLetterOrContractsRequired: "Intent letter or contracts required",

    // Transaction
    sourceTypeInvalid: "Invalid source type",
    destinationTypeInvalid: "Invalid destination type",
    forTypeInvalid: "Invalid for type",
    transactionTypeInvalid: "Invalid transaction type",
    discountPositive: "Discount must be positive",
    receiptInvalid: "Receipt must be valid",
    refundExceedsCredit: "More than the credit memo has left to refund",
    attachmentInvalid: "Attachment must be valid",
    feeInvalid: "Fee must be a valid amount",

    // User
    commissionFlatRateRange: "Flat rate must be between 0 and 100",
    commissionMinMarginRange: "Min margin must be between 0 and 100",
    commissionTypeInvalid: "Invalid commission type",
    drawAmountPositive: "Draw amount must be positive",
    poidInvalid: "PO ID must be unique and between 1–999",
    pojobRange: "PO job must be at most 99999",
    typeNotEmployee: "Type must not be employee",

    // Vehicle
    vehicleTypeInvalid: "Invalid vehicle type",
    locationInvalid: "Invalid location",
    mileagePositive: "Mileage must be greater than zero",
    statusInvalid: "Invalid status",

    // VendorTerms
    labelConflict: "Label conflicts with an existing term",
    netDaysExceedsMax: "Net days exceeds maximum",
    netBufferRange: "Net buffer must be 1–31",
    discountRange: "Discount must be between 0 and 100",
    discountDaysRange: "Discount days must be less than net days",

    // Service
    allFieldsRequired: "Please fill in all required fields",
    completingService: "Error completing service",
    creatingIssue: "Error creating issue",
    descriptionRequired: "Description required",
    generatingPdf: "Error generating PDF",
    loadingAlreadyCompleted:
      "Loading has already been completed for this delivery.",
    loadingWorkOrder: "Error loading work order",
    nameRequired: "Name required",
    quoteNeedsProject: "Issue must have a project to create a quote",
    reasonRequired: "Reason required",
    saving: "Error saving",
    savingField: "Error saving field",
    schedulingPunchout: "Failed to schedule punchout",
    servicePhaseChangeNotAllowed:
      "This project's service can't move to that step right now. Refresh the page and try again.",
    startingService: "Error starting service",
    technicianRequired: "Please select at least one technician",
    vehicleRequired: "Please select a vehicle",
    videoTooLarge: "Video must be less than 50MB",
    videoTooLong: "Video must be 15 seconds or less",

    // Shown by formatError in place of a Firebase or browser error's own
    // (technical) message
    accountDisabled: "This account has been disabled.",
    accountExists: "This person already has an account.",
    browserBlocked:
      "Your browser blocked this. Allow it in your browser's settings and try again.",
    busy: "The system is busy right now. Wait a minute and try again.",
    canceled: "That was canceled.",
    changedElsewhere:
      "Someone else changed this at the same time. Please try again.",
    emailInUse: "Another account already uses this email address.",
    emailInvalid: "Enter a valid email address.",
    linkExpired: "This link has expired or was already used.",
    noPermission: "You don't have permission to do that.",
    notFound: "That could not be found. It may have been deleted.",
    offline:
      "Your device is offline. Check its internet connection and try again.",
    signInAgain:
      "For your security, sign out and sign back in, then try again.",
    timeout:
      "That took too long. Check your device's internet connection and try again.",
    tooManyAttempts: "Too many attempts. Wait a few minutes and try again.",
    unauthenticated: "You're signed out. Sign in and try again.",
    unexpected: "Something went wrong. Please try again.",
    weakPassword: "Choose a longer password — at least 6 characters.",
    wrongPassword: "The email address or password is incorrect.",

    404: "Sorry, this page doesn't exist.",
    accessDenied: "ACCESS DENIED",
    contractQuoteTotalMismatch:
      "The contract total does not equal the final quote total",
    creditLimitExceeded: "This account's credit limit has been reached",
    exceedsInvoicedTotal: "Amount exceeds invoiced total",
    failedCreatingCustomerQuote: "Unable to create customer copy of the quote",
    failedCreatingEmail: "Failed to create outgoing email",
    failedLoadingImages: "Some images failed to load",
    failedUploadingFiles: "Failed to upload file(s)",
    failedUpdatingFiles: "Failed to upload, modify, or delete file(s)",
    geolocationUnsupported: "Your browser doesn't support geolocation",
    inventoryItemNotFound: "Inventory Item no longer exists",
    quoteNotAvailable:
      "This quote is no longer available. Please contact your sales representative.",
    quoteResponseExists:
      "A response to this quote was already submitted but hasn't been processed, so it can't be declined or resubmitted. Please contact an administrator.",
    aiAnalysisTimeout:
      "AI analysis took too long and was cancelled. Try again, or use a CSV or XML export from your quoting tool instead.",
    inventoryItemUnavailable: "Inventory Item no longer available",
    invoiceNoEmail:
      "The billing contact has no email address, so the invoice could not be emailed",
    invoiceNoItems:
      "No items are available to invoice. Items must be fully delivered or linked to a fully installed labor to be invoiced.",
    loadStoredPdf: "Failed to load the stored PDF",
    noItemsFound: "No items found",
    notChangeOrder: "The selected quote is not a change order",
    pdfImageUnavailable:
      "A picture could not be loaded, so the PDF could not be made. Check your internet connection and try again, or re-add the picture.",
    pdfViewer: "Failed to load the PDF viewer",
    quoteImageUnavailable:
      "One or more quote images are no longer available. Please re-add the missing image(s) and try again.",
    quoteInvalid: "Quote can't be saved yet — missing or invalid: {reasons}.",
    salesGoalFailed: "Failed to load sales goal",
    serviceUnavailable: "Service temporarily unavailable. Please try again.",
    "terms-labor":
      "The terms are material-only, but the quote includes labor. Please remove all labor items or change the terms to continue.",
    "terms-material":
      "The terms are installation-only, but the quote includes material. Please remove all material items or change the terms to continue.",
    "terms-no-labor":
      "The terms include installation, but no installation is quoted. Please add a labor item or change the terms to continue.",
    unreadableFile:
      "That file could not be read. Check that it is a complete export from your quoting tool, then try again.",
    unsupportedFormat:
      "That file type can't be imported. Choose a CSV, XML or PDF file.",
    updateCheckFailed: "Unable to check for updates",
    "An account for this email address already exists":
      "An account for this email address already exists",
    "An account for this person already exists":
      "An account for this person already exists",
    "Incorrect email address": "Incorrect email address",

    // Sample
    labelPrinterFailed:
      "The printer could not print. Check that it is turned on, has labels loaded and is close to this device, then try again.",
    locationAccessDenied: "Location access denied",
    locationUnavailable:
      "Your device could not find its location. Check that location services are turned on, then try again.",
    popupsBlocked: "Allow pop-ups to print the label",
    sampleLoadFailed: "Error loading sample",
    sampleNotFound: "Sample not found",
    samplePickupFailed: "Error sending pickup request",
    webBluetoothUnsupported:
      "Bluetooth printing is not supported in this browser — use Chrome or Edge",
  },

  success: {
    callLogSaved: "Call log saved",
    companyRequested: "Company account requested. Accounting will review it.",
    defaultReceivingMapSet: "Default receiving map updated",
    itemsTransferred: "Transferred {count} item | Transferred {count} items",
    warehouseMapActivated: "Warehouse map activated",
    warehouseMapArchived: "Warehouse map archived",
    warehouseMapDeactivated: "Warehouse map deactivated",
    warehouseMapUnarchived: "Warehouse map restored",
    warehouseMapSaved: "Warehouse map saved",
    warehouseMapsReordered: "Warehouse maps reordered",
    warehouseMapDeleted: "Warehouse map deleted",
    canceledSale: "Sale canceled successfully",
    copied: "Copied!",
    customerAccountCreated: "Account created! Please verify your contact info",
    emailDeleted: "Email deleted",
    emailProcessing: "Email processing",
    emailQueued: "Email queued for delivery",
    emailReassigned: "Email reassigned",
    emailSent: "Email sent",
    emailVerified: "Email address verified",
    entryCreated: "Entry created",
    entryDeleted: "Entry deleted",
    entrySaved: "Entry saved",
    expenseDeleted: "Expense deleted",
    expenseReopened: "Expense reopened",
    expenseReviewed: "Expense reviewed",
    expenseSubmitted: "Expense submitted",
    expenseUpdated: "Expense updated",
    feedbackReceived: "Thanks for your feedback!",
    financeChargeAssessed: "Finance charge assessed",
    financeChargeNotified: "Finance charge notice sent",
    financeChargeRemoved: "Finance charge removed",
    heldPayAdjusted: "Held pay balance adjusted",
    issueCompleted: "Service issue marked complete",
    issueDeferred: "Issue saved and deferred",
    issueReported: "New issue reported",
    issueReportedCustomer:
      "Issue reported successfully. Our service team will review it shortly.",
    issueReviewed: "Issue marked as reviewed and ready to schedule",
    laborReportSent: "Report sent!",
    libraryFileDeleted: "File moved to Trash",
    libraryFilePurged: "File permanently deleted",
    libraryFileRestored: "File restored",
    libraryFolderDeleted: "Folder deleted",
    libraryFolderSaved: "Folder saved",
    loadingComplete: "Loading complete - ready for departure",
    mergedDuplicates: "Merged 1 duplicate | Merged {count} duplicates",
    mileageEntrySaved: "Mileage entry saved",
    mileageRateSaved: "Mileage rate saved",
    mileageSubmitted: "Mileage submitted for reimbursement",
    otherAckDeleted: "Acknowledgement deleted",
    otherAckReceived: "Marked received",
    otherAckSaved: "Acknowledgement saved",
    partsOrdered: "Parts marked as ordered",
    partsReceived: "Parts marked as received",
    passwordChanged: "Password changed",
    payrollReminders:
      "No employees need reminders | Sent reminder to {count} employee | Sent reminders to {count} employees",
    pdfRegenerated: "PDF regenerated successfully",
    preferenceSaved: "Saved to your preferences",
    preferenceSavedFor: "Saved to {name}'s preferences",
    progressSaved: "Progress saved",
    projectFileDeleted: "File deleted",
    projectFilesUploaded: "Files uploaded",
    punchoutScheduled: "Punchout scheduled successfully",
    punchoutClosedOut: "Punchout marked complete",
    pickupRequestSent: "Pickup request sent",
    receivingSessionCanceled: "Receiving session canceled",
    receivingSessionDeleted: "Receiving session deleted",
    resetPasswordSent: "Password reset email sent.",
    saleCreated: "All orders for this sale use this PO: <strong>{po}</strong>",
    quoteResponseSent:
      "Your response has been sent to the sales representative. Thanks!",
    restored: "Restored!",
    salesGoalUpdated: "Sales goal updated",
    serviceCompleted: "Service completed successfully",
    serviceStarted: "Service started",
    sampleCreated: "Sample created",
    sampleDiscarded: "Sample discarded",
    sampleDroppedOff: "Sample dropped off",
    sampleLabelPrinted: "Label sent to printer",
    sampleLocationUpdated: "Sample location updated",
    sampleReturnedToOffice: "Sample returned to office",
    sampleUpdated: "Sample updated",
    undoDelivery: "Delivery undone. The items are back on the truck.",
    updateAvailable: "A new version is available",
    updateCheckComplete: "No updates found",
    vendorCaseClosed: "Vendor case closed",
    workOrderCancelled: "Work order cancelled",
  },

  warning: {
    unmappedLocations:
      "Inventory is assigned to zones not on this map: {zones}. Add these zones so those items stay visible and selectable.",
    collectMaterialBeforeDelivery:
      "This cash sale has an outstanding material balance of {amount} that must be collected before delivery. Scheduling this delivery will notify accounting to collect the balance.",
    chargeableIssues:
      "This project has 1 chargeable issue. Ensure customer approval before scheduling. | This project has {count} chargeable issues. Ensure customer approval before scheduling.",
    companyContact:
      "This company has no company account yet. Request one: quotes can be sent to it once accounting approves it.",
    companyRequested:
      "This company's account is awaiting accounting's approval. Quotes can be sent to it once it's approved.",
    companyDuplicate:
      "This company may already exist. Open it, use its contact, or mark it as not a duplicate before saving.",
    companyDuplicateRequest:
      "This company may already have an account. Ask accounting, or mark it as not a duplicate: accounting will review it.",
    courtesyAmountManagerNotified:
      "Manager will be notified of this courtesy amount.",
    disableUserPersonalFiles:
      "This user has {count} personal file(s) ({size}) in the Document Library. Admins cannot read personal files; if you need to keep this data, log in as the user and move it to a shared tier or download it before deactivating the account.",
    issuesWaitingOnParts:
      "1 issue is waiting on parts and cannot be added until parts arrive | {count} issues are waiting on parts and cannot be added until parts arrive",
    itemsNotOnDelivery:
      "Some items on the truck are no longer on this delivery, so this is a partial delivery. They will not be marked delivered: unload them after submitting.",
    itemsOnDifferentTruck:
      "Some items for this sale are loaded on a different truck.",
    laborerUnavailable:
      "Quoted laborer {names} is no longer available | Quoted laborers {names} are no longer available",
    locationNeedsBin:
      "{location} holds numbered bins. Scan the bin label or enter the bin number.",
    noAddress: "Missing address",
    notAllIssuesSelected:
      "Not all issues selected - remaining items may be chargeable if not completed",
    partsWithoutIssues:
      "Parts in stock but no issues reported - this may indicate a problem",
    personalLibraryFull:
      "Your personal Document Library is full. Delete old or unused files to make room.",
    personalLibraryNearFull:
      "Your personal Document Library is more than 80% full. Delete old or unused files to make room.",
    punchoutAlreadyCompleted:
      "We have already completed a punchout for this project. Should this visit be chargeable?",
    quoteBackupMissingImages:
      "Removed 1 expired local image from backup. Please re-add it before saving. | Removed {count} expired local images from backup. Please re-add them before saving.",
    salesTax:
      "The project appears to be outside your default county.  Please make sure you have the correct sales tax applied.",
    salesTaxCountySelection:
      "Address lookup failed, so we fell back to ZIP code lookup. Please select the correct county to apply sales tax.",
    unschedulableParticipants:
      "{names} is no longer available to schedule. Consider adding a replacement installer. | {names} are no longer available to schedule. Consider adding replacement installers.",
    urgentServiceHotList:
      "This issue will appear on the Urgent Service Hot List.",
    vehicleHasScheduledDelivery:
      "This vehicle has a delivery already scheduled. Loading here may cause conflicts.",
    xmlMissingDescriptions:
      "This XML file doesn't include descriptions. Try exporting as a CSV file instead.",
    xmlMissingItems:
      "This XML file doesn't include any items or is not yet supported. Please try using a CSV if possible, or contact support.",
  },

  hint: {
    auditHistoryReason: "Required for audit history",
    binCount: "Highest bin number in this zone (leave blank for open-ended)",
    binList:
      "Which bins of zone {zone} should be printed? Enter numbers and ranges, e.g. 1-20, 25 (up to {max} at a time).",
    defaultReceivingMap: "The map preselected for receiving and put-away.",
    transferEmptyLocation: "Nothing is stored in this location.",
    transferEmptyBin: "Nothing is stored in this bin.",
    transferSelectDestination: "Click the destination zone on the map.",
    transferSelectSource:
      "Click a zone on the map to see and move what's stored there.",
    warehouseName:
      "Enter a short warehouse name (used as the location prefix). It can't contain '/', ':' or ','.",
    gridSize: "Snap grid spacing, in map units",
    labelSize: "Font size for zone labels, in map units",
    warehouseMapActive:
      "Only active maps offer their zones for receiving and put-away.",
    callLogContact: "Select a contact, or enter a name below",
    cannotUndo: "This action cannot be undone.",
    ccCallOffice: "Call the office with the credit card to process payment.",
    fieldPaymentNeedsReview:
      "This payment was collected in the field and needs to be reviewed.",
    fromStock: "Taken from our stock instead of purchased for this job",
    fieldPaymentVerified: "This field payment has been verified.",
    followUpAction: "e.g. Send Quote",
    snapshotConflicts:
      "1 change was also made by someone else while you were editing | {count} changes were also made by someone else while you were editing",
    valueChanged: "(changed)",
    andNMoreChanges: "and 1 more difference | and {count} more differences",
    showNMoreSales: "Show 1 more sale | Show {count} more sales",
    paymentAlreadyCollected:
      "A payment has already been collected for this sale.",
    checkColumns: "Double-check that relevant columns are correctly labeled.",
    commissionNotSelectable:
      "Only commissions that are ready for approval or already approved can be reconciled.",
    commissionPaidButIncomplete:
      "This commission is marked paid but is not in a paid state: either the sale is not yet complete, or the link to its paycheck is missing. Review it before paying again.",
    deferOrdering:
      "Purchasers are told when it is ready to order, instead of you.",
    deliverHardware: "Hardware is NOT to be held.",
    deliverScreens: "Screens are NOT to be held.",
    deliveryNotifications:
      "Send loading and transit notifications to the customer",
    duplicateTarget:
      "{contactName} is already a target contact for {salespersonName}. You may still add this contact, but consider coordinating with {salespersonName} first.",
    deliveryBalance:
      "Before unloading, remember to confirm that someone on site is available to pay the balance for this cash sale!",
    deliveryForPickup: "These items are to be picked up by the customer.",
    deliveryProof:
      "Take photos or videos of the unloaded items and of the overall jobsite.",
    deliveryToWarehouse:
      "This goes to one of our warehouses, so it is not the final delivery.",
    extractImagesPrompt:
      "Some items are missing images. Would you like to extract images from the imported PDF now?",
    holdHardware: "Hardware IS to be held.",
    holdScreens: "Screens ARE to be held.",
    installationBalance:
      "Upon completion of this installation, remember to confirm that someone on site is available to pay the balance for this cash sale!",
    installationProof: "Take photos or videos of the installed items.",
    librarySearch: "Names and descriptions, across every folder you can open",
    librarySearchLimited:
      "Showing the first {shown} of {total} matches. Keep typing to narrow them down.",
    logDocFilter:
      "An ID, a path, or a project/sale pair. Matches that document and everything under it, and is searched on its own.",
    matchImages: "Match each image with its line item.",
    mergeKept: "This record is kept. Details from the others are added to it.",
    mergeRemoved: "This record is merged into the kept one, then deleted.",
    optional: "Optional",
    overpayment: "Overpayment: {x}",
    payrollReminder:
      "This will send a notification to all employees who have commissions ready for approval or held commission pay, reminding them to review and submit their paycheck.",
    pencilEvent: "Tentative schedule; material not yet received",
    quoteName: "This helps your customer identify the quote.",
    readOnlyFolder:
      "Everyone with access can open and download these files, but only administrators can add, rename, move or delete anything here.",
    refundableCredit: "Credit left to refund: {x}",
    registerCustomerAccount:
      "Set your password to review your estimate and receive updates regarding your order.",
    remainingBalance: "Remaining balance is {x}.",
    selectColumns: "Identify relevant columns.",
    selectQuoteFile:
      "Select a Quote <b>PDF</b>, <b>CSV</b>, or <b>XML</b> file.<br/><b>BE SURE TO EXPORT AT OUR COST!</b>",
    foundXImages: "Found 1 image | Found {count} images",
    scanRequestPickup: "Scan to request pickup",
    selectImagePDF: "Select a PDF file containing item images.",
    selectRelevantImages:
      "Drag any split images to combine them. Then, adjust the criteria below to automatically select relevant images. Finally, scroll through and ensure that only relevent images are selected. If some images are missing, try lowering the Vector Overlap value.",
    targetContact: "Select a contact you plan to focus on this year",
    totalPayments: "Amount paid: {x}",
    useCurrentLocation: "Use my current location",
    username:
      "This is your personal account. Please do not change your name to your company name.",
    verifyData: "Make sure everything looks right.",
    vehicleName: "e.g. 2020 Toyota Tundra - Black",
    expenseReceipt: "Take a photo of your receipt or upload a PDF.",
    saleCostReceipt: "Upload a photo of the receipt or a PDF invoice.",
    sampleBorrowerContact: "Select a contact, or enter a name below",
    sampleHomeLocation: "Default destination for the Return action",
    samplePickupInstructions:
      "Click the button below to let us know you are ready for us to pick it up.",
    sampleScanPrompt: "What would you like to do?",
    sampleScanToTrack: "Scan this code to track this sample",
    sampleThanks: "Thank you for taking care of our sample!",
    commissionClawback:
      "Final costs put this sale below the profit it was advanced against. The difference comes off other commission on the paycheck; if the check cannot absorb it, payroll posts the remainder to held pay to recover later.",
    advanceAvailable:
      "The customer paid the full order up front, so half the expected commission can be claimed on the next payroll. It is deducted from the final commission when the sale completes.",
    commissionAdvance:
      "Prepays part of the expected commission on a sale that is not finished. Only sales with commission still to come are listed; the advance is deducted from the actual commission when the sale completes.",
    commissionAdvanceNote:
      "Shown with the advance on the salesperson's commission record.",
    commissionShare: "Shares divide the sale's commission and must total 100%.",
    commissionRate:
      "A % of sale is paid on the sale's pre-tax total, off the top, and comes out of the shares.",
    leadCommissionSplit:
      "Each split is a % of the sale's pre-tax total, paid to that employee off the top and deducted from your commission.",
    commissionClawbackSplit:
      "{amount} of this recovers the advance; the rest is a negative balance on the sale itself.",
    heldPayNegativeBalance:
      "This takes held pay below zero. The employee will owe {amount}, recovered from a future paycheck.",
    shippingChargeUnderThreshold:
      "This quote is under {threshold} pre-tax. The standard shipping/delivery charge is {amount}. Set the amount to add it, or zero it out to save without.",
    shippingWaiveInternal: "Internal only — the customer will not see this.",
    cashSalePaidInFullOverride:
      "Internal only — required to override. The customer will not see this.",
    cashSaleUnderThreshold:
      "This cash sale is under {threshold} and will need the terms set to paying the balance in full to place the order.",
    miscItemIsShipping:
      "Pass-through freight. Excluded from commission and summed into the sale's shipping total; the customer still sees it as a normal line.",
    memberHasLogin:
      "Has a login: as a member, sees this company's quotes and invoices",
    wholesaleCompany:
      "Mark this customer as a wholesale account. Sales billed to this company do not pay commission or count toward sales goals.",
    wholesaleAccount: "Sales billed to this account do not pay commission.",
    closeVendorCase: "Close the vendor's warranty case",
    closeVendorCaseAfterVisit:
      "Close the vendor's warranty case after this visit",
    inspectionVisit:
      "Verify what's needed on site. This visit confirms scope rather than completing the repair.",
    issueBlockedOnParts: "Cannot add until parts are received",
    issuePhotoCloseUp: "Close-up showing the problem clearly",
    issuePhotoOverall: "Overall unit standing back",
    issuePhotos: "Please provide 2 photos:",
    issueVideo:
      "A short video (15 seconds or less) can help show the issue in action.",
    noOpenIssuesAtLocation:
      "No open issues for this location. You can add new issues below.",
    openIssuesEstimate: "Open issues estimate: {hours}h",
    punchoutWalkItems:
      "1 item to walk: {hours}h | {count} items to walk: {hours}h",
    receivedUndeliveredItems:
      "These items have been received but not yet delivered/installed. Add them to the work order loading checklist.",
    scheduleNowOrLater:
      "You can schedule now or save first and schedule later from the calendar.",
    schedulerOpensAfterSave:
      "Calendar scheduler will open after saving to select a time slot.",
    serviceIssueDeliveryOnly:
      "No service visit - the customer picks up the parts or has them delivered",
    serviceIssueLaborQuote:
      "A quote for labor will need to be created after review",
    serviceIssueQuote:
      "A service quote will need to be created after this issue is reviewed",
    serviceIssueVendorCase:
      "Once the service is completed, the issue waits in Vendor Cases to Close until someone marks the case closed",
    serviceIssueWarranty: "No quote needed - warranty covers parts and labor",
    serviceJobOver4Hours:
      "Jobs over 4 hours may require multiple technicians or time slots.",
  },

  quote: {
    approveProtected:
      "We're excited to hear you would like to move forward with this sale! This is not a final quote, but you will receive a finalized version containing detailed line item information for approval.",
    declined: {
      competition: "Check back soon for the next sales competition!",
      canceled: "Project is on hold or canceled",
      revision: "Plans are being revised",
      obsolete: "This version is obsolete",
      na: "Prefer not to say",
    },
    "expect-po-contract":
      "The customer will be providing a Purchase Order or Contract.",
    expired: "Quotes are valid for 30 days, but you can request a new one.",
    generalSpecs:
      "Color: Standard, unless otherwise specified\nGlass: Low-E with Argon, unless otherwise specified\nTempering: Where required by code or specified by architect\nHardware: Standard color, unless otherwise specified",
    orderBalanceExceeded:
      "Orders for this vendor exceed expected total by {balance}.",
    orderBalanceMet: "Orders for this vendor meet expected total.",
    orderBalanceRemaining:
      "{balance} remaining of expected total for this vendor's orders.",
    requestUpdate:
      "We're excited to hear you would like to move forward with this sale! This quote is older than 30 days, but you will receive an updated version containing current pricing.",
    dateRequiredBeforeLeadTime:
      "Please Note: The customer's date requested is less than manufacturing lead times for {brand} ({leadTime}).",
    "see-po-contract": "See Purchase Order or Contract",
  },

  order: {
    directShip: "This order will be direct shipped.",
    manHours: "Man-Hours",
    noMaterial: "This order does not contain any material items.",
    isFinal: "This is the final order for this vendor.",
    laborer: "Technician | Technicians",
    orderCopyMissing: "I don't have a copy of the order.",
    remaining: "There will be another order for this vendor.",
  },

  cost: {
    balanceExceeded: "Actual cost exceeds expected by {balance}.",
    balanceMet: "Actual cost meets expected total.",
    balanceRemaining: "{balance} remaining of expected cost.",
  },

  discount: {
    ackShortfall:
      "Expected {percent}% additional discount is not reflected in the acknowledged cost (expected {target} or less). It may still be applied at billing — review the amount.",
    billShortfall:
      "Expected {percent}% additional discount is not reflected in the billed cost (expected {target} or less). Review the amount.",
    expectedLabel: "Additional Discount Expected",
    percentLabel: "Discount off standard cost (%)",
    targetLabel: "Expected cost after discount",
    vendorShortfall:
      "Billed cost for {vendor} does not reflect the expected additional discount (expected {target} or less). Review the amount.",
  },

  ack: {
    ackCopyMissing: "I don't have a copy of the acknowledgement.",
    extracting: "Extracting data from document...",
    extractionApplied: "Document data applied to empty fields.",
    extractionFailed:
      "Couldn't read the acknowledgement. Please enter its details by hand.",
    isFinalForOrder: "This is the final acknowledgement for this order.",
    pendingDate: "Expected date is pending.",
    remainingForOrder: "There will be another acknowledgement for this order.",
    reviewed: "This acknowledgement has been reviewed.",
    // A reorder for a service issue (Ack.serviceIssueID)
    forServiceIssue: "For service issue",
    forServiceIssueHint:
      "Receiving this order marks the issue's parts received",
    // Near misses on a hand-typed vendor order number (util/vendorOrderNumber)
    closestMatch:
      "No acknowledgement carries {slip}. Closest: {ack}, {reason}.",
    reasonZeros: "differs by a zero",
    reasonOneEdit: "one character off",
    // What the vendor sync found out about the order number (Ack.vendorOrderCheck)
    vendorOrderContested:
      "{vendor} lists order {number} for PO {vendorPO}. {claimedBy} carries the same order number, and its packages are expected there. Correct the order number on whichever acknowledgement is wrong.",
    vendorOrderContestedHeld:
      "{vendor} lists order {number} for PO {vendorPO}. {claimedBy} carries the same order number, and nothing shows which of the two it belongs to, so neither is updated and the warehouse will ask before receiving its packages. Correct the order number on whichever acknowledgement is wrong.",
    vendorOrderIsOurs: "This order is ours",
    vendorOrderIsOursConfirm:
      "{vendor} lists order {number} for PO {vendorPO}. Keep it on {expectedPO}? It will no longer be flagged, and the warehouse will receive its packages without asking.",
    vendorOrderMismatch:
      "{number} is the vendor's order for PO {vendorPO}, not {expectedPO}.",
    vendorOrderUnlisted:
      "The vendor ships {suggested} for this PO; this acknowledgement says {number}.",
    vendorOrderUnverifiable:
      "{vendor} lists order {number} for PO {vendorPO}, not {expectedPO}. If this order number is another job's, correct it.",
    vendorOrderNeedsReview: "Order number needs review",
    useVendorOrderNumber: "Use {number}",
    vendorOrderNumberUpdated: "Order number updated to {number}.",
    vendorPOAccepted: "Order {number} (PO {vendorPO}) marked as ours.",
    vendorPONotAccepted:
      "The order could not be marked as ours. Try again later, or ask an admin.",
    fixVendorOrderNumber:
      "Correct the acknowledgement's order number to {number}",
  },

  bill: {
    billCopyMissing: "I don't have a copy of the bill.",
    creditCopyMissing: "I don't have a copy of the credit memo.",
    isFinalForAck: "This is the final bill for this acknowledgement.",
    isFinalForOrder:
      "This is the final bill for the whole order (1 other acknowledgement will be marked billed). | This is the final bill for the whole order ({count} other acknowledgements will be marked billed).",
    remainingForAck: "There will be another bill for this acknowledgement.",
  },

  packingSlip: {
    backordered: "Back-ordered",
    missingRecord:
      "This packing slip cannot be opened: its {record} no longer exists. The record was deleted while the packing slip under it survived.",
    record: {
      sale: "sale",
      order: "order",
      packingSlip: "packing slip",
    },
    crossDockVehicle: "Cross-dock to vehicle",
    directShip: "This is a direct shipment.",
    itemsDirectShipped: "Direct-shipped",
    itemsIncluded: "Included on the packing slip",
    itemsReady: "Ready to be delivered",
    originalDescription: "Original description for order line {line}:",
    packingSlipCopyMissing: "I don't have a copy of the packing slip.",
    qcComplete: "QC inspection completed",
    receivedBackorders: "Received with backorders",
    receivedComplete: "Received complete",
    receivedIncomplete: "Partially received",
    receivedIssues: "Received with damages or missing items",
    skipQC: "Skip QC inspection",
    skipQCCaption: "Items will go directly to delivery without inspection",
    skipQCReason: "Reason for skipping QC",
  },

  labelScan: {
    photograph: "Photograph the shipping label",
    typeInstead: "Type or paste the label text instead",
    pasteText: "Label text",
    read: "Read this text",
    reading: "Reading the label…",
    showText: "Show what was read",
    size: "Size",
    callout: "Callout",
    unknownVendor: "Unrecognised label",
    unnamedItem: "Unnamed item",
    noRoom: "No room recorded",
    poUnanchored:
      "PO found loose on the label, not beside its caption — check it",
    noSale: "No sale found for PO {po}",
    noCandidates:
      "Nothing on this sale matched. Check the text that was read, or choose the item by hand.",
    ambiguous:
      "The evidence could not tell these apart — check before choosing",
    choosePanel: "This carton is one panel of a unit. Which unit is it?",
    choosePanelOf: "This carton is panel {index} of {of}. Which unit is it?",
    panel: "Panel",
    panelOf: "Panel {index} of {of}",
    whichSlip: "Which delivery is this carton on?",
    noOpenSlip:
      "That sale has no packing slip still open to receiving, so there is nothing to receive against.",
  },

  vendor: {
    noOrderNumber:
      "No vendor order number found. Please enter it on the acknowledgement first.",
    noShipments: "No shipment data available for this order.",
    receiveTracking: "Vendor Scan",
    syncComplete: "Vendor shipping data synced successfully.",
    syncShipments: "Sync Vendor Shipments",
    syncMismatch:
      "{number} belongs to PO {vendorPO}, not {expectedPO}. Nothing was synced — check the acknowledgement's order number.",
    match: {
      unknown: "Linked, but matched before confidence was recorded",
      high: "Confident match",
      medium: "Probable match",
      low: "Weak match",
    },
    matchedOn: "Matched on",
    matchEvidence: "Evidence: {available} of {total}",
    scanDidYouMean: "Closest matches — check before choosing",
    scanSuggestions:
      "No exact match. {count} possible item(s) — pick one or rescan.",
    packageOnAnotherTruck:
      "That package is on truck {truck}, not the truck this packing slip covers.",
    notYetScoped:
      "Showing every truck for this order. The first scan records which truck this packing slip covers.",
    scopedToTruck:
      "Showing truck {truck} — the truck this packing slip covers.",
    slipTruckNotSynced:
      "This packing slip covers truck {truck}, which is not in the synced shipment data. Sync vendor shipments to load it.",
    multipleTrucksScanned:
      "Packages from more than one truck were scanned onto this packing slip ({trucks}). A slip normally covers one truck — only the first was recorded.",
    matchNone:
      "Not linked to a sale item — receiving this will not mark anything ready",
    matchNotInterchangeable:
      "Could not be told apart from a different product — check before receiving",
    unmatchedReceivedItems:
      "{count} scanned package(s) are not linked to a sale item, so nothing was marked ready. Reconcile the shipment lines first.",
    // A sale's quote numbers, per vendor (Sale.vendorQuotes)
    addQuoteNumber: "Add another {vendor} quote number",
    quoteNumberFor: "{vendor} Quote Number",
    // What the vendor sync found out about one of them (Sale.vendorQuoteChecks)
    quoteNumberNearMatch:
      "Vendor order {order} is from quote {suggested}, one character off this sale's {number}, so it was not placed on this sale.",
    quoteNumberNeedsReview: "Vendor quote number needs review",
    quoteNumberUpdated: "Quote number updated to {number}.",
    useQuoteNumber: "Use {number}",
  },

  warehouse: {
    addPOManually: "Add PO Manually",
    alreadyReceived: "This item has already been received.",
    alreadyScanned: "This barcode has already been scanned in this session.",
    anotherReceiver: "another receiver",
    assignToPO: "Assign to PO",
    beingFinished: "Being finished",
    cancelReceiving: "Cancel receiving?",
    cancelReceivingConfirm:
      "Everything scanned on this truck will be reset and will NOT be received. Any other receivers' scans on it are reset too. This cannot be undone.",
    cancelReceivingEmpty:
      "Leave this truck? The session will be canceled — nothing on it has been received.",
    cancelReceivingLeave: "Leave this truck",
    cancelReceivingOk: "Reset this truck",
    completeAndSave: "Complete & Save Packing Slips",
    completedScanNotKept:
      "{carton} was not filed — the truck had been completed. Scan it again on the truck's next pass: Continue it from Recent trucks.",
    completeFailedTitle: "Not every PO was saved",
    completeInterrupted:
      "This truck was taken over on another device while its packing slips were being saved, so it was not completed. The slips already saved stay saved; whoever has the truck now finishes it.",
    completeNotLead:
      "This truck was taken over, canceled or completed on another device, so nothing was saved here.",
    completeReceiving: "Complete Receiving",
    confirmScan: "Confirm",
    expectedItems: "items expected",
    expectedShipments: "Expected Shipments",
    exitedByLead:
      "The lead paused this truck. You've been returned to Receiving — rejoin it from Recent trucks.",
    exitedCanceled:
      "The lead canceled this truck and its scans were reset. You've been returned to Receiving.",
    exitedFinished:
      "The lead is finishing this truck. You've been returned to Receiving.",
    exitedTakenOver:
      "Someone else took the lead on this truck. You've been returned to Receiving.",
    exitScanning: "Exit",
    finishAnyway: "Finish anyway",
    finishingElsewhere:
      "Someone else is finishing this truck on their device, so nothing was changed. Take it over from the row's menu only if that device is lost or dead.",
    finishScanning: "Finish",
    finishWhileLed:
      "Someone else is leading this truck right now, so it was not finished from here. Take it over from the row's menu first if they have left it.",
    importFailed: "Failed to import packing slip. Please try again.",
    importPackingSlip: "Import Packing Slip",
    importSuccess: "{count} items imported from packing slip.",
    itemProgress: "{received} of {quantity} received",
    itemsImported: "items imported",
    itemType: "Item Type",
    keepScanningHere: "Keep scanning here",
    keepTruckOpen: "Keep the truck open",
    missingItems: "Missing Items",
    n_completeFailed:
      "Every PO was saved | 1 PO could not be saved. {reasons} Its scans are kept on this truck: try again, or finish without it and receive that PO by packing slip. | {count} POs could not be saved. {reasons} Their scans are kept on this truck: try again, or finish without them and receive those POs by packing slip.",
    n_expectedShipments:
      "No expected shipments | 1 expected shipment | {count} expected shipments",
    n_extraCartons:
      "Screens, hardware & accessories: none scanned yet | Screens, hardware & accessories: 1 carton scanned | Screens, hardware & accessories: {count} cartons scanned",
    n_itemsOnPO:
      "No items on the PO | 1 item on the PO | {count} items on the PO",
    n_packagesInCarton:
      "No items in carton | 1 item in carton | {count} items in carton",
    n_receiveOverUnmatched:
      "Receive one {item} without scanning? | {po} already has 1 unit scanned that is not tied to an item, and it may be this {item}. Receive one more without scanning only for a unit that is still on the truck with no label. | {po} already has {count} units scanned that are not tied to an item, and this {item} may be among them. Receive one more without scanning only for a unit that is still on the truck with no label.",
    n_scansNotListedYet:
      "Every scan is listed | 1 carton was scanned that this screen does not list yet, so nothing was saved. Wait a moment for it to appear, check it, and save again. | {count} cartons were scanned that this screen does not list yet, so nothing was saved. Wait a moment for them to appear, check them, and save again.",
    n_scansOnNoPO:
      "Every scan is on a PO | 1 scan is on no PO on this truck, so finishing would not receive it — {scans}. Keep the truck open to find its PO, or finish without it. | {count} scans are on no PO on this truck, so finishing would not receive them — {scans}. Keep the truck open to find their POs, or finish without them.",
    n_trucks: "No trucks | 1 truck | {count} trucks",
    n_unmatchedUnits:
      "No units scanned without an item | 1 unit scanned, not tied to an item | {count} units scanned, not tied to an item",
    n_POs: "No POs | 1 PO | {count} POs",
    noBarcode: "No Barcode",
    photographLabel: "Photograph the shipping label",
    otherWays: "Other ways to identify this carton",
    noBarcodeCaption: "Prints a new one — records the box, not its contents",
    labelChooseOrder:
      "PO {po} has more than one order, and none is on this truck yet. Which one did this carton come on?",
    labelConfirmOrder:
      "PO {po} is not on this truck. If this carton came on it, tap it to add it to the truck.",
    labelFirstHint:
      "{vendor} barcodes identify the box, not what is in it — photograph the label instead.",
    readLabelInstead: "Read the label",
    labelNoPO:
      "No PO could be read from that label. Try another photo, or use No Barcode.",
    labelOrderReceived: "Already received in full",
    labelOtherOrder:
      "That label is for PO {po}, which is not one of the orders being received. The carton may be on the wrong pallet.",
    labelReadCancelled:
      "The label read was cancelled, so nothing was received from that photo. Photograph the label again if its carton still needs receiving.",
    noExpectedShipments:
      "No expected shipments found. Please add POs manually.",
    noMatchingOrders: "Type at least 2 characters to search",
    noOrdersToLink: "No other orders available to link to.",
    noPOsSelected:
      "No POs selected. A Marvin truck needs none: start receiving and scan any package, and the truck and every PO on it are picked up from the first scan. For other vendors, add the truck's POs here first — one left out can still be added from a carton's label photo, or by searching for it on the carton's card.",
    noScansYet: "No items scanned yet. Scan a barcode to begin.",
    noShipDate: "No ship date from the vendor yet",
    nothingExpectedYet:
      "Nothing expected yet — scan a package to identify the truck.",
    nothingListed:
      "Nothing listed for the chosen POs yet — scan or photograph each carton and file it under its PO.",
    allScanned: "Every package on this truck has been scanned.",
    openReceiveHint:
      "Scan any package. A Marvin scan picks up its truck and every PO on it, and a Quaker scan its PO; for other vendors, photograph the label, or search for the PO on the carton's card.",
    ordersNotAdded:
      "Not added to truck {truck}, which is another vendor's: {pos}. Receive them in a session of their own.",
    truckIdentified: "Receiving truck {truck} — {pos}",
    otherTruck:
      "That package is on truck {other}. This session is receiving truck {truck}; finish it before starting the next truck.",
    packagesToGo: "{count} to go",
    onLaterTrucks: "{count} more on later trucks — still expected, not missing",
    openMissingIssues:
      "Open a missing-material sale issue for each item left on the truck ({count})",
    missingUnmatched:
      "{count} of the missing packages could not be tied to a sale item, so no sale issue can be opened for them. They stay on the missing list above.",
    missingIssueDescription:
      "Not on truck {truck} when it was unloaded {date}: {packages}",
    missingIssueDescriptionNoTruck: "Not received {date}: {packages}",
    n_issuesOpened:
      "No missing-material sale issues opened | 1 missing-material sale issue opened for follow-up | {count} missing-material sale issues opened for follow-up",
    n_issuesResolved:
      "No missing-material sale issues closed | 1 missing-material sale issue closed — the material arrived | {count} missing-material sale issues closed — the material arrived",
    missingResolved: "Received on truck {truck} {date}",
    recentTrucks: "Recent trucks",
    n_sessions:
      "No sessions this week | 1 session this week | {count} sessions this week",
    started: "started",
    cancelSession: "Cancel session",
    continueTruck: "Continue",
    deleteSession: "Delete session",
    finishInstead: "Keep them — finish receiving this truck",
    n_scansReverted:
      "No scans taken back | 1 scan taken back off the vendor's records | {count} scans taken back off the vendor's records",
    revertScans: "Take the scans back off — nothing was received",
    resumeSession: "Resume",
    joinSession: "Join",
    takeOver: "Take over receiving",
    takeOverFinishingConfirm:
      "Someone else is finishing this truck on their device. Take it over only if that device is lost or dead: its Complete step stops before saving anything more, and the truck goes back to scanning on yours.",
    pauseSession: "Pause",
    pendingScanNeedsBin:
      "File {carton} first — it still needs a bin in {location}. Scan the bin label or dismiss it, then try again.",
    pendingScanNeedsLocation:
      "File {carton} first — it still needs a location. Set one or dismiss it, then try again.",
    pendingScanNeedsPO:
      "File {carton} first — it still needs a PO. Assign one or dismiss it, then try again.",
    pendingScanNeedsPOAndLocation:
      "File {carton} first — it still needs a PO and a location. Set both or dismiss it, then try again.",
    pendingScanNeedsPOCheck:
      "File {carton} first — {vendor} lists it for PO {vendorPO}, not {po}. Check its label, then tap Receive anyway or dismiss it, and try again.",
    pendingScanNeedsPOCheckAndBin:
      "File {carton} first — it still needs a bin in {location}, and {vendor} lists it for PO {vendorPO}, not {po}. Scan the bin label and check its label, then tap Receive anyway or dismiss it, and try again.",
    pendingScanNeedsPOCheckAndLocation:
      "File {carton} first — it still needs a location, and {vendor} lists it for PO {vendorPO}, not {po}. Set one and check its label, then tap Receive anyway or dismiss it, and try again.",
    pendingScanNotKept:
      "{carton} was not filed — it still needed a PO or a location. Scan it again when you're back on the truck.",
    pendingScanNotKeptFinishing:
      "{carton} was not filed — it still needed a PO or a location, and the lead is finishing this truck. Ask the lead to go Back to the truck and scan it before saving.",
    pendingScanNotKeptPOCheck:
      "{carton} was not filed — {vendor} lists it for PO {vendorPO}, not {po}, and nobody confirmed it. Check its label, and scan it again on this truck if it is ours.",
    pendingScanNotKeptPOCheckFinishing:
      "{carton} was not filed — {vendor} lists it for PO {vendorPO}, not {po}, nobody confirmed it, and the lead is finishing this truck. Ask the lead to go Back to the truck, check its label and scan it before saving, if it is ours.",
    posOpenElsewhere:
      "Some of these POs are already being received by {name}. Open that session instead of starting a second one?",
    sessionCanceled: "This truck was canceled — nothing on it was received.",
    sessionNotLeft:
      "This session could not be closed, so it is still open in Recent trucks. Finish or cancel it there.",
    sessionPaused:
      "Truck paused. Everything scanned is kept — resume it from Recent trucks to finish.",
    openSession: "Open session",
    noRecentTrucks: "Nothing received in the last 7 days.",
    noPackingSlipCopy: "I don't have a copy of the packing slip.",
    packingSlipFile: "Packing Slip Document",
    // The card's Confirm while Marvin lists its package for another PO
    receiveAnyway: "Receive anyway",
    receiving: "Receiving",
    receivingComplete: "Receiving complete. Packing slips created.",
    refreshVendor: "Refresh vendor shipment data",
    reportIssue: "Report Sale Issue",
    scanHistory: "Scan History",
    scanOrType: "Scan barcode or type tracking number",
    quickReceive: "Quick receive",
    quickReceiveAt:
      "Filing each unit at {location} without stopping to confirm.",
    quickReceiveHint:
      "File each unit at the last location automatically, without stopping to confirm.",
    scanSaved: "Saved",
    scansOnNoPOTitle: "Scans on no PO",
    scansPutBack:
      "Put back, not received: {cartons}. Scan them again on truck {truck}.",
    scanUndone: "Scan undone.",
    scanning: "Scanning",
    searchPO: "Search by PO number or vendor",
    selectedPOs: "Selected POs",
    startReceiving: "Start Receiving",
    startSeparateSession: "Start a separate session anyway",
    toggleCamera: "Toggle camera scanner",
    truckNoLongerOpen:
      "Truck {truck} is no longer open in that session. Keep scanning here.",
    truckOpenElsewhere:
      "Truck {truck} is already being received by {name}. Open that session instead? What you scanned here is put back, so scan it again there.",
    typeToSearch: "Type at least 2 characters to search POs",
    linkedTo: "Linked to",
    linkToPO: "Link to PO",
    linkToPOMessage: "Select the PO this order's scans should count toward:",
    unknownBarcode: "Unknown barcode — assign to a PO below",
    uploadPackingSlip: "Upload packing slip file",
    vendorPOElsewhere:
      "{vendor} lists this package for PO {vendorPO}, not {po}. Check the label before receiving it.",
    vendorPOListed: "{vendor} lists PO {vendorPO}",
    waitingForLocationScan: "Waiting for location scan for",
    warehouseBarcodes: "Warehouse Barcodes",
    warehouseLocationBarcodes: "Warehouse location barcodes",
    noWarehouseLocations:
      "No active warehouse maps have zones yet. Activate a map on the Warehouse Maps page to print its labels.",
    openBins: "Numbered bins — choose which to print",
    selectWarehouses: "Select one or more warehouses to show their barcodes.",
    n_labelsPrinted:
      "No labels sent to the printer | 1 label sent to the printer | {count} labels sent to the printer",
    barcodePrinted: "Barcode label sent to printer.",
    noAckFound: "No acknowledgement found for PO {po}",
    popupBlocked:
      "Your browser blocked the print window. Please allow popups for this site and try again.",
    printBarcode: "Print barcode label",
    receiveManually: "Receive without scanning",
    warehouseTools: "Warehouse Tools",

    // Bulk packing slip scan
    scanPackingSlips: "Scan Packing Slips",
    scanPackingSlipsHint: "Scan or upload one PDF of all the truck's slips",
    scanNoSlips: "No packing slips could be read from that PDF.",
    scanFailed: "Failed to process the packing slips. Please try again.",
    scanAdded:
      "No orders added | 1 order added from the scan | {count} orders added from the scan",
    reconcileTitle: "Match Packing Slips",
    reconcileSubtitle:
      "{count} slips found — confirm the sale each belongs to before adding",
    reconcileSlips: "Scanned slips",
    reconcileMissing: "Expected, no slip scanned",
    reconcileNoSlip: "no packing slip in this scan",
    slipNoPO: "No PO on slip",
    slipPages: "Pages {range}",
    slipOrderNo: "Order #",
    n_lineItems: "No line items | 1 line item | {count} line items",
    slipExtractionFailed: "line items could not be read",
    matchedPoVon: "PO + order # confirmed",
    matchedPo: "PO match",
    matchedVon: "Order # match",
    matchedPoVendor: "PO + vendor match",
    slipUnassignedNote:
      "From the truck scan: packing slip PO {po}, vendor order {von}, pages {pages}",
    skipSlip: "Skip",
    confirmAndAdd: "Confirm & Add",
    suggestedMatch: "Suggested",
    // The truck's manifest, pulled from the vendor when the first scan names a truck
    n_truckOrdersUnplaced:
      "Every order on truck {truck} is known here | 1 order on truck {truck} is not in Northern Approach and was added as unassigned | {count} orders on truck {truck} are not in Northern Approach and were added as unassigned",
    truckUnplacedNote:
      'Truck {truck}: vendor order {order} for PO "{po}" ({customer}) has no order in Northern Approach.',
    truckManifestFailed:
      "Could not pull the truck's manifest from the vendor; expecting only the orders already known.",
    n_ackNumbersFixed:
      "No order numbers corrected | 1 order number corrected | {count} order numbers corrected",

    // Quaker cartons: the barcode names the sales order, line and unit
    lookingUpOrder: "Looking up Quaker order {order}…",
    orderIdentified: "{po} added to this truck",
    quakerAccessory: "Accessory package {package}",
    quakerLookupNotKept:
      "Quaker order {order} was still being looked up, so its carton was not filed, nor anything scanned after it. Scan them again when you're back on the truck.",
    quakerOrderBarcode:
      "That barcode names only the order ({po}). Scan the long barcode at the top of the label.",
    quakerOrderUnknown:
      "No PO's acknowledgement has Quaker order {order} — assign it to a PO below.",
    quakerPackage: "Line {line}, unit {unit}, package {package}",
    quakerUnit: "Line {line}, unit {unit}",

    // QC Scan
    qcScan: "QC Scan",
    qcScanSubtitle: "Scan received items to inspect",
    qcInspect: "Inspect",
    qcViewInspection: "View Inspection",
    qcReadyToInspect: "Ready for QC inspection",
    qcAlreadyInspected: "Already QC inspected",
    qcBarcodeNotFound:
      "Barcode not found in any packing slip. Item may not have been received yet.",
    qcPendingList: "Pending QC",
    qcNoPending: "No packing slips pending QC inspection.",
    qcAccessories: "Accessories from this order",
    qcSelectItem: "Select matching item",

    // Unassigned Receiving
    receiveUnassigned: "Receive Unassigned Material",
    unassignedPOLabel: "PO on shipment label",
    unassignedVendor: "Vendor (if known)",
    addUnassigned: "Add unassigned PO",
    statusUnassigned: "Unassigned",
    statusAssigned: "Assigned",
    statusSample: "Sample",
    statusService: "Service",
    unassignedMaterial: "Unassigned Material",
    unassignedMaterialSubtitle: "Material received without a matching PO",
    noUnassignedMaterial: "No unassigned material in the warehouse",
    assignToProject: "Assign to Project",
    markAsSample: "Mark as Sample",
    markAsService: "Mark as Service",
    assignedToOrder: "{po} assigned to {order}",
    markedAsSample: "{po} marked as sample",
    markedAsService: "{po} marked as service",
    unassignedNotes: "Notes",
    unassignedItems: "{count} item | {count} items",
    unassignedReceivedOn: "Received {date}",
  },

  // Acknowledgements that are not for a sale (Warehouse Tools > Other
  // Acknowledgements), and receiving them
  otherAck: {
    alsoReceives: "Also receives: {name}",
    assignTo: "Or an acknowledgement or service issue",
    entryLabel: "{type} · {name}",
    markReceivedPrompt: "Where was it put? Leave blank if you don't know.",
    n_received:
      "No acknowledgements marked received | 1 acknowledgement marked received | {count} acknowledgements marked received",
    noneToAssign: "No acknowledgements or service issues are waiting",
    receivedAt: "At {location}",
    receivedWindow: "Received in the last 90 days",
  },

  // Parts for service issues: Order Parts on the issue, matching and marking
  // them received on the Receiving page
  serviceParts: {
    addIssue: "Add a service issue",
    caseNumber: "Case {number}",
    caseNumberPrompt:
      "Mark the vendor's warranty case closed. Add or correct its case number if you have it.",
    entryLabel: "Service · {po} · {issue}",
    expectedFor:
      "No service issues | Parts for service issue: {issue} | Parts for {count} service issues",
    n_received:
      "No service issues marked | Parts received for 1 service issue — ready to schedule | Parts received for {count} service issues — ready to schedule",
    n_skipped:
      "No service issues skipped | 1 service issue was not marked: it is no longer waiting on parts | {count} service issues were not marked: they are no longer waiting on parts",
    n_stillToCome:
      "Nothing still to come | 1 package still to come | {count} packages still to come",
    noIssues: "No open service issues are waiting on parts",
    onTruck: "Truck {truck}",
    orderNumber: "Vendor order {number}",
    orderNumberHint: "Receiving matches arriving parts to this issue by it",
    orderNumberPrompt:
      "The vendor's order number or service request number, if you have one. Receiving matches the parts to this issue by it when they arrive.",
    reason: {
      ack: "Acknowledged for this issue",
      added: "Added here",
      item: "Same item",
      order: "Reorder for this issue",
      orderNumber: "Order number match",
      picked: "Assigned while scanning",
      sale: "Only issue waiting on the sale",
    },
    title: "Service issues",
  },

  issue: {
    backorder: "Back-Ordered",
    closed: "Resolved",
    damage: "Damaged or Wrong",
    missing: "Missing",
    missingItems: "Item missing from delivery | Items missing from delivery",
    open: "Unresolved",
    orderRequired: "This requires a new order",
    psLine: "Delivery Line",
    qcReport:
      "The following issue(s) were found during a quality control inspection:",
    qtyAffected: "Qty Affected",
    unusable: "Item is unusable",
  },

  message: {
    paymentReceipt: {
      subject: "Payment Received",
      body: "We have received your payment of {amount} for {for}.<br/><br/>Thank you!",
    },
    sendQuote: {
      subject: "New Quote",
      body: 'Thank you for the opportunity to quote your project!<br/><br/>Please click here to review your estimate for <a href="{url}">{jobsite}</a>.<br/><br/>This link will allow you to review, approve, request changes, or, in the unfortunate event that you have decided to go another direction, decline our proposal.<br/><br/>If the link above does not work, please use this URL:<br/><a href="{url}">{url}</a>',
      bodyProtected:
        'Thank you for requesting a quote for <a href="{url}">{jobsite}</a>!<br/><br/>This quote is for bidding purposes only. If you would like to move forward with this project, please click the above link to open the quote and select "Request Final Quote" at the bottom, or simply let your salesperson know that you would like to proceed.<br/><br/>Thank you for the opportunity!<br/><br/>If the link above does not work, please use this URL:<br/><a href="{url}">{url}</a>',
    },
    followupQuote: {
      subject: "Quote Followup",
      body: 'Thank you for the opportunity to quote your project!<br/><br/>Please click here to review your estimate for <a href="{url}">{jobsite}</a>.<br/><br/>This link will allow you to review, approve, request changes, or, in the unfortunate event that you have decided to go another direction, decline our proposal.<br/><br/>If the link above does not work, please use this URL:<br/><a href="{url}">{url}</a>',
      bodyProtected:
        'Thank you for requesting a quote for <a href="{url}">{jobsite}</a>!<br/><br/>This quote is for bidding purposes only. If you would like to move forward with this project, please click the above link to open the quote and select "Request Final Quote" at the bottom, or simply let your salesperson know that you would like to proceed.<br/><br/>Thank you for the opportunity!<br/><br/>If the link above does not work, please use this URL:<br/><a href="{url}">{url}</a>',
    },
    sendInvoice: {
      subject: "Invoice {id} for {po}",
      body: "Attached is invoice {id} for sale {po}.",
    },
    followupInvoice: {
      subject: "Followup on Invoice {id} for {po}",
      body: "Attached is another copy of invoice {id} for sale {po}.",
    },
    financeChargeNotice: {
      subject: "Finance Charge on Invoice {id} for {po}",
      body: "A late-payment finance charge has been applied to invoice {id} for sale {po}, which is past due. The attached invoice reflects the updated balance including the finance charge.<br/><br/>Please remit payment at your earliest convenience. If your payment has already been sent, please disregard this notice.",
    },
    sendCreditMemo: {
      subject: "Credit Memo {id} for {po}",
      body: "Attached is credit memo {id} for sale {po}.",
    },
    sendFeedbackRequest: {
      subject: "Looking for your Feedback",
      body: "Customer feedback is vital to knowing what needs the most focus in any business. We consider our company to be among the best and always believe that the decisions we make for our direction are in our customers' best interest. It is a rather large and foolish assumption that we know better than our customers when it comes to our strengths and weaknesses. We want to take the assumptions away and really get focused on the needs of the people that make our business possible.<br/><br/>If you have a moment for just a few questions to help us better serve you, please follow the link below and take the short survey. <strong>Please be brutally honest</strong>. This feedback will come directly to our ownership for review. You will not hurt our feelings.<br/><br/>Don't recognize the \"Northern Approach\"? We hope that you will be seeing it a lot more frequently soon. This is our new app that will be giving you a lot more access to information and providing more frequent updates regarding your quotes, orders, deliveries, and services.<br/><br/>Thank you for all of the opportunities and your time.<br/><br/>Justin Ciak - CEO<br/>NWD, Inc. & Fenestram, Inc.",
    },
  },

  feedback: {
    customer: {
      title: "Customer Feedback",
      thanks: "Thank you for your feedback!",
      other: "Other (please specify)",
      overallSatisfaction: {
        question: "Overall, how satisfied are you with {company}?",
        options: [
          { value: 7, label: "Very satisfied" },
          { value: 6, label: "Satisfied" },
          { value: 5, label: "Somewhat satisfied" },
          { value: 4, label: "Neither satisfied nor dissatisfied" },
          { value: 3, label: "Somewhat dissatisfied" },
          { value: 2, label: "Dissatisfied" },
          { value: 1, label: "Very dissatisfied" },
        ],
      },
      serviceSatisfaction: {
        question: "Which services are you most satisfied with?",
        options: [
          { value: "showroom", label: "Showroom" },
          { value: "products", label: "Product Selection" },
          { value: "sales", label: "Sales Staff" },
          { value: "delivery", label: "Delivery Services & Staff" },
          { value: "service", label: "Field Services & Staff" },
          { value: "communication", label: "Communication" },
        ],
      },
      serviceDissatisfaction: {
        question: "Which services are you least satisfied with?",
        options: [
          { value: "showroom", label: "Showroom" },
          { value: "products", label: "Product Selection" },
          { value: "sales", label: "Sales Staff" },
          { value: "delivery", label: "Delivery Services & Staff" },
          { value: "service", label: "Field Services & Staff" },
          { value: "communication", label: "Communication" },
        ],
      },
      requests: {
        question:
          "What services or products would you like to see {company} offer?",
      },
      greatestWeakness: {
        question: "Please be direct; what is our greatest weakness?",
      },
      restaurant: {
        question: "What is your favorite restaurant?",
      },
    },
  },

  mask: {
    "date-event": "YYYY-MM-DD",
    "date-time-event": "YYYY-MM-DD HH:mm",
    "date-standard": "YYYY/MM/DD",
    "date-time-standard": "YYYY/MM/DD HH:mm",
    "date-short": "M/D/YYYY",
    "date-time-short": "M/D/YYYY h:mma",
    "date-full": "dddd, MMMM D, YYYY",
    "date-time-full": "dddd, MMMM D, YYYY h:mma",
  },

  format,

  terms: {
    vendor: {
      types: {
        "1% 10 Net 30": "1% 10 Net 30",
        "Net 30": "Net 30",
      },
      standard: {
        label: "Standard",
        netDays: {
          prefix: "Net due in",
          suffix: "day | days",
        },
        discount: {
          prefix: "Discount is",
          suffix: "",
        },
        discountDays: {
          prefix: "Discount if paid within",
          suffix: "day | days",
        },
      },
      dateDriven: {
        label: "Date-Driven",
        netDays: {
          prefix: "Net due before day",
          suffix: "of the month",
        },
        netBuffer: {
          prefix: "Due the next month if issued within",
          suffix: "day of due date | days of due date",
        },
        discount: {
          prefix: "Discount is",
          suffix: "",
        },
        discountDays: {
          prefix: "Discount if paid before day",
          suffix: "of the month",
        },
      },
    },
    allSales:
      "Buyer shall be responsible for payment of Seller for goods delivered and/or services provided in accordance with the signed order, and if Buyer fails to pay, nothing shall prevent Seller from filing a mechanics lien and/or filing a complaint to recover the balance due in the Common Pleas Court of Franklin County, Ohio. In the event the Court determines Buyer failed to pay Seller when due without good cause, Seller shall be entitled to recover from Buyer in addition to the balance owed, interest and court costs, reasonable attorney fees incurred to collect the balance due.\nIt is agreed that all sales, whether invoiced to the purchaser in his or its individual, corporate or partnership name or in any trade name or in the name of any subsidiary or in the name is any officer or agent, should nevertheless be an indebtedness of the purchaser hereon stated.\nSeller disclaims all warranty of suitability of material for any particular purpose. Seller does not warrant items as to merchantability, and specifically sells such items “as is” and purchaser shall look to the manufacturer for any warranty that may be applicable to such item. Seller is not liable for consequential damages resulting from any claimed breach of warranty, expressed or implied.\nPurchaser agrees to immediately examine shipment and agrees to notify seller promptly of any errors or shortages in shipment and of any damaged or defective material supplied.\nUse of material shall constitute a waiver of any error in shipment or defect in material, which might have been determined by a prompt and diligent inspection thereof.\nSeller retains title and a security interest in all building materials until paid for and purchaser grants seller permission, upon purchaser’s default or communication that materials are unacceptable, to enter all premises over which purchaser may have control to reclaim possession to such materials.\nThe exclusive warranty on materials for this transaction shall be the manufacturer’s warranty on products sold.",
    cashInstalled: {
      label: "Cash Sale – Installed",
      text: "Payment of {downPaymentPercent} to be made at the time of order execution. Material and labor are billed separately. The remaining balance for material is due before delivery; material will not be delivered until that balance has been collected. The balance for labor is due upon completion of installation, and the installer will collect it prior to leaving the site after a completion report is signed. Buyer must be on site at completion.\nIf payment is made by credit card, it is understood that additional processing fees will be added to the balance owed.",
    },
    cashInstallOnly: {
      label: "Cash Sale – Installation Only",
      text: "No deposit is required; this sale is for installation labor only. The full balance is due upon completion of installation, and the installer will collect it prior to leaving the site after a completion report is signed. Buyer must be on site at completion.\nIf payment is made by credit card, it is understood that additional processing fees will be added to the balance owed.",
    },
    cashMaterialOnly: {
      label: "Cash Sale – Material Only",
      text: "Payment of {downPaymentPercent} to be made at the time of order execution. The remaining {remainderPercent} balance is due before delivery; material will not be delivered until the balance has been collected.\nIf payment is made by credit card, it is understood that additional processing fees will be added to the balance owed.",
    },
    cashPaidInFull: {
      label: "Cash Sale – Paid in Full",
      text: "Full payment to be made at the time of order execution.\nIf payment is made by credit card, it is understood that additional processing fees will be added to the balance owed.",
    },
    accountInstalled: {
      label: "Account Sale – Installed – Discount",
      text: "Upon approval and credit extension, I/we agree to pay in full within <strong>{discountDays} days</strong> from substantial completion of installation for a {discountPercent} discount, or <strong>net {netDays} days</strong>. In the event such a payment is not remitted within {discountDays} days with a {discountPercent} discount, or non-discounted balance within {netDays} days, the purchaser does agree to pay a Finance Charge daily at {financeChargeMonthlyPercent} Monthly (Annual Percentage Rate of {financeChargeAnnualPercent}) until the full amount is paid.\nIf payment is made by credit card, it is understood that additional processing fees will be added to the balance owed.",
    },
    accountInstalledNoDiscount: {
      label: "Account Sale – Installed – No Discount",
      text: "Upon approval and credit extension, I/we agree to pay in full within <strong>{netDays} days</strong>. In the event such a payment is not remitted within {netDays} days, the purchaser does agree to pay a Finance Charge daily at {financeChargeMonthlyPercent} Monthly (Annual Percentage Rate of {financeChargeAnnualPercent}) until the full amount is paid.\nIf payment is made by credit card, it is understood that additional processing fees will be added to the balance owed.",
    },
    accountMaterialOnly: {
      label: "Account Sale – Material Only – Discount",
      text: "Upon approval and credit extension, I/we agree to pay in full within <strong>{discountDays} days</strong> from delivery for a {discountPercent} discount, or <strong>net {netDays} days</strong>. In the event such a payment is not remitted within {discountDays} days with a {discountPercent} discount, or non-discounted balance within {netDays} days, the purchaser does agree to pay a Finance Charge daily at {financeChargeMonthlyPercent} Monthly (Annual Percentage Rate of {financeChargeAnnualPercent}) until the full amount is paid.\nIf payment is made by credit card, it is understood that additional processing fees will be added to the balance owed.",
    },
    accountMaterialOnlyNoDiscount: {
      label: "Account Sale – Material Only – No Discount",
      text: "Upon approval and credit extension, I/we agree to pay in full within <strong>{netDays} days</strong>. In the event such a payment is not remitted within {netDays} days, the purchaser does agree to pay a Finance Charge daily at {financeChargeMonthlyPercent} Monthly (Annual Percentage Rate of {financeChargeAnnualPercent}) until the full amount is paid.\nIf payment is made by credit card, it is understood that additional processing fees will be added to the balance owed.",
    },
    commercialInstalled: {
      label: "Commercial – Installed",
      text: "Please refer to attached Purchase Order or Contract for agreed upon terms that may be different from those on this quote.\nBuyer understands that once Seller places the order for the materials covered by this contract or purchase order with the manufacturer, if Buyer cancels the order or changes the specifications, it shall be responsible to the Seller for expenses incurred and loss of profit caused to Seller as a result of its actions.\nTerms for material only sales are <strong>net {netDays} days</strong> from the date of delivery unless otherwise agreed upon via Contract or Purchase Order. There shall be no retainage held on material for this sale.",
    },
    commercialMaterialOnly: {
      label: "Commercial – Material Only",
      text: "Please refer to attached Purchase Order or Contract for agreed upon terms that may be different from those on this quote.\nThis transaction is for the sales and delivery of materials and does not include installation or other services. Therefore, any provisions of an attached Purchase Order/Contract applicable to a contractor providing services shall not apply to this transaction. The provisions of Ohio Law governing sale of goods, including but not limited to delivery, acceptance, and rejection of goods sold, shall apply.\nBuyer understands that once Seller places the order for the materials covered by this contract with the manufacturer, if Buyer cancels the order or changes the specifications, it shall be responsible to the Seller for expenses incurred and loss of profit caused to Seller as a result of its actions.\nTerms for material only sales are <strong>net {netDays} days</strong> from the date of delivery unless otherwise agreed upon via Contract or Purchase Order. There shall be no retainage held on material for this sale.",
    },
  },

  inventoryCount: {
    addExtra: "Add extra item",
    completeCount: "Complete Count",
    completedBy: "Completed by {name}",
    confirmComplete:
      "Complete this count? Any unchecked items will be recorded as missing in the report.",
    confirmDelete: "Delete this inventory count? This cannot be undone.",
    confirmReopen: "Reopen this count for further edits?",
    countedOf: "{counted} of {expected} counted",
    countedQty: "Counted",
    discrepancies: "Discrepancies",
    expectedItems:
      "No expected items | 1 expected item | {count} expected items",
    expectedQty: "Expected",
    expectedValue: "Expected value",
    exportCsv: "Export CSV",
    extraDescription: "Item description",
    extraQty: "Quantity found",
    includeVehicles: "Include vehicles",
    newCount: "New Count",
    print: "Print",
    progress: "Progress",
    reopen: "Reopen",
    results: {
      extra: "Extra",
      match: "Match",
      missing: "Missing",
      partial: "Quantity off",
      pending: "Not counted",
    },
    startCount: "Start Count",
    statuses: {
      active: "In progress",
      complete: "Complete",
    },
    title: "Count title",
    titlePlaceholder: "e.g. Q1 Warehouse Count",
    variance: "Variance",
  },
};
